// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/select_arow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/ongoing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/sold.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.ManagerDashboard_dashboard__V1Jm8 {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
  padding-right: 0px;
}

.ManagerDashboard_dashboardContain__YHSYl {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_dashboardContain__YHSYl,
.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_dashboard__V1Jm8,
.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_cont2__\\+vbCD {
  background-Color: #0f1824;
}

.ManagerDashboard_top_header__h0v1i .ManagerDashboard_top_header_inner__C2o3F {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.ManagerDashboard_cont2__\\+vbCD {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /*height: calc(100vh - 160px);*/
  height: 100%;
  min-height: auto !important;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.ManagerDashboard_subLink__KfY5X svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.ManagerDashboard_cst_vendr__\\+HUCx input {
  min-height: 35px !important;
}

.ManagerDashboard_cst_vendr__\\+HUCx .ManagerDashboard_form-control__JXIhW {
  background-color: #f5f6fa;
  border: none;
}

.ManagerDashboard_footer__0PZX3 {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.ManagerDashboard_bodythemelight__uo0IO {
  background-color: #fff;
  padding-top: 90px;
}

.ManagerDashboard_bodythemedark__iFTXF {
  background-color: #132337;
  padding-top: 90px;
}

.ManagerDashboard_bodythemeNew__Dlybx {
  background-color: #f5f6fa;
}

/* 
Header Navbar Theme
*/
.ManagerDashboard_headerthemelight__jsrKj {
  background-color: #fff;
}

.ManagerDashboard_headerthemedark__484DS {
  background-color: #132337;
}

.ManagerDashboard_top_header__h0v1i {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.ManagerDashboard_menuthemelight__MdJ2i {
  background-color: #f5f6fa;
}

.ManagerDashboard_menuthemedark__ZKyZF {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.ManagerDashboard_menulinklight__DS2ZT span {
  color: #666666 !important;
}

.ManagerDashboard_menulinklight__DS2ZT a {
  color: #CBCBCB !important;
}

.ManagerDashboard_menulinklight__DS2ZT:hover span,
.ManagerDashboard_menulinklight__DS2ZT:hover a {
  color: #fff !important;
}

.ManagerDashboard_menulinkdarkSelected__FUO-t {
  background-color: #1c2e45;
  color: #3b82f6;
}

.ManagerDashboard_menuthemelight__MdJ2i .ManagerDashboard_menulinklightSelected__2RGM8 {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43 !important;
}

.ManagerDashboard_menulinkdark__XJEFF {
  color: #92afd3 !important;
}

.ManagerDashboard_menulinklight__DS2ZT:hover {
  color: #fff !important;
  background-color: #131F43 !important;
}

.ManagerDashboard_menulinklight__DS2ZT .ManagerDashboard_sub_arrow__RNK9E svg path {
  stroke: #CBCBCB !important;
}

.ManagerDashboard_menulinklight__DS2ZT:hover .ManagerDashboard_sub_arrow__RNK9E svg path {
  stroke: #fff !important;
}

.ManagerDashboard_menulinkdark__XJEFF .ManagerDashboard_sub_arrow__RNK9E svg path {
  stroke: #92afd3 !important;
}

.ManagerDashboard_menulinkdark__XJEFF:hover .ManagerDashboard_sub_arrow__RNK9E svg path {
  stroke: #fff !important;
}

.ManagerDashboard_menulinklight__DS2ZT:hover svg path,
.ManagerDashboard_menulinklightSelected__2RGM8 svg path {
  fill: #fff !important;
}

.ManagerDashboard_menulinkdark__XJEFF:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.ManagerDashboard_headinglight__9p6zm {
  color: #60677e;
}

.ManagerDashboard_headingdark__gmWm8 {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.ManagerDashboard_searchboxlight__68OdW {
  background-color: #fff;
  border: none;
}

.ManagerDashboard_searchboxdark__1LeH9 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.ManagerDashboard_searchboxdark__1LeH9::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.ManagerDashboard_tableheadlight__JsZMi {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.ManagerDashboard_tableheadlight__JsZMi th {
  color: #fff;
}

thead .ManagerDashboard_tableheadlight__JsZMi th:first-child,
thead .ManagerDashboard_tableheaddark__WdsJz th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .ManagerDashboard_tableheadlight__JsZMi th:last-child,
thead .ManagerDashboard_tableheaddark__WdsJz th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.ManagerDashboard_table__T9Yb\\+.ManagerDashboard_table-borderless__X6yRe {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.ManagerDashboard_tableheaddark__WdsJz {
  background-color: #132337;
  color: #fff;
}

.ManagerDashboard_table-borderless__X6yRe tr:nth-child(even) {
  background-color: #F9FAFB;
}

.ManagerDashboard_table-borderless__X6yRe .ManagerDashboard_left-section__HudV4 {
  padding-top: 10px;
}

.ManagerDashboard_tablebodylight__VlaBZ td,
.ManagerDashboard_tablebodydark__4qXqa td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.ManagerDashboard_tablebodylight__VlaBZ {
  background-color: #fff;
}
.ManagerDashboard_tablebodylight__VlaBZ:hover {
  background-color: #fff;
  cursor: auto;
}
.ManagerDashboard_tablebodylight__VlaBZ p {
  line-height: 24px;
}

.ManagerDashboard_tablebodydark__4qXqa {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.ManagerDashboard_tablebodydark__4qXqa:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.ManagerDashboard_paginationlight__rdhxA {
  color: #60677e !important;
  font-size: 13px !important;
}

.ManagerDashboard_paginationdark__M1l2p {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.ManagerDashboard_formthemelight__ryMW6 {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.ManagerDashboard_formthemedark__mxeuv {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.ManagerDashboard_formthemedark__mxeuv ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.ManagerDashboard_viewformlight__y3yi8 {
  background-color: #f3f6f9;
}

.ManagerDashboard_permissionboxlight__qZZa3 {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.ManagerDashboard_permissionboxdark__siTrO {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.ManagerDashboard_errormsgclr__-JPzw {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.ManagerDashboard_graphclrlight__igJYK {
  background-color: #fff;
}

.ManagerDashboard_graphclrdark__CsRde {
  background-color: #132337;
}

/* 
Counter theme
*/
#ManagerDashboard_card1bglight__TlXvX {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#ManagerDashboard_card1bgdark__88TAE {
  background: #392f28;
}

#ManagerDashboard_card2bglight__dKe4a {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#ManagerDashboard_card2bgdark__\\+0Pjl {
  background: #1c3238;
}

#ManagerDashboard_card3bglight__\\+Irxb {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#ManagerDashboard_card3bgdark__CR9gh {
  background: #3a2434;
}

#ManagerDashboard_card4bglight__ZqSMH {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#ManagerDashboard_card4bgdark__Npc5V {
  background: #2f264f;
}

#ManagerDashboard_card1bgdark__88TAE a,
#ManagerDashboard_card1bgdark__88TAE p,
#ManagerDashboard_card2bgdark__\\+0Pjl a,
#ManagerDashboard_card2bgdark__\\+0Pjl p,
#ManagerDashboard_card3bgdark__CR9gh a,
#ManagerDashboard_card3bgdark__CR9gh p,
#ManagerDashboard_card4bgdark__Npc5V a,
#ManagerDashboard_card4bgdark__Npc5V p {
  color: #fff;
}

/* 
Action button theme
*/
.ManagerDashboard_actionbtnlight__CILfC {
  color: rgba(70, 71, 91, 0.8705882353);
}

.ManagerDashboard_actionbtndark__gd73c {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.ManagerDashboard_profiledropdownlight__3Luiv {
  background-color: #fff;
}

.ManagerDashboard_profiledropdowndark__45qA6 {
  background-color: #151521;
}

.ManagerDashboard_settingsection__M\\+J1d #ManagerDashboard_addform__aiztJ.ManagerDashboard_formthemedark__mxeuv .ManagerDashboard_savebtn__GGZxf {
  background-color: #3b82f6;
  color: #fff;
}

#ManagerDashboard_addform__aiztJ.ManagerDashboard_formthemedark__mxeuv .ManagerDashboard_savebtn__GGZxf {
  background-color: #3b82f6;
  color: #fff;
}

.ManagerDashboard_profile_conatiner__ALk40 {
  border-radius: 5px !important;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_ag-theme-alpine__fYKut .ManagerDashboard_ag-row__D7L05 {
  background: #000 !important;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_formbtn__LyU5E {
  background-color: #3b82f6;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_formbtn__LyU5E:hover {
  background-color: #2563eb;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_resetbtn__lcA26 {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_resetbtn__lcA26:hover {
  background-color: #3b82f6;
}

.ManagerDashboard_headingdark__gmWm8 span {
  background-color: #132337;
}

.ManagerDashboard_resetbtn__lcA26 {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 5px !important;
  background-color: transparent !important;
  border: solid 1px #131F43 !important;
  color: #131F43 !important;
  min-width: 113px !important;
}

.ManagerDashboard_resetbtn__lcA26:hover,
.ManagerDashboard_resetbtn__lcA26:active,
.ManagerDashboard_resetbtn__lcA26:focus {
  background-color: #131F43 !important;
  color: #fff !important;
}

.ManagerDashboard_addBtn__2T8jP {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.ManagerDashboard_addDltBtn__eENjf {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.ManagerDashboard_addbtnlight__xK01k {
  background-color: #38A169;
}

.ManagerDashboard_addbtndark__dt7-k {
  background-color: #3b82f6;
}

.ManagerDashboard_addbtndark__dt7-k:hover {
  background-color: #2563eb;
}

.ManagerDashboard_formthemedark__mxeuv label {
  color: #92afd3;
}

.ManagerDashboard_addBtn__2T8jP svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.ManagerDashboard_addBtn__2T8jP:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.ManagerDashboard_cust_addBtn__k\\+-1V.ManagerDashboard_addBtn__2T8jP svg {
  top: 2px;
}

.ManagerDashboard_deleteBtn__ZbUql {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.ManagerDashboard_deleteBtn__ZbUql {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.ManagerDashboard_deleteBtn__ZbUql:active,
.ManagerDashboard_deleteBtn__ZbUql:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.ManagerDashboard_deleteBtn__ZbUql svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.ManagerDashboard_deleteBtn__ZbUql:hover,
.ManagerDashboard_deleteBtn__ZbUql:active,
.ManagerDashboard_deleteBtn__ZbUql:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.ManagerDashboard_confirmBtn__bdk5W {
  background-color: #131F43 !important;
  min-width: 130px !important;
  height: 50px !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
}

.ManagerDashboard_confirmBtn__bdk5W:hover,
.ManagerDashboard_confirmBtn__bdk5W:active,
.ManagerDashboard_confirmBtn__bdk5W:focus {
  background-color: #0f1824 !important;
}

.ManagerDashboard_confirmBtn__bdk5W svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.ManagerDashboard_delPopContainer__fuxVD .ManagerDashboard_modal-body__8LzsZ {
  padding: 35px;
  text-align: center;
}

.ManagerDashboard_delPopContainer__fuxVD .ManagerDashboard_delet_icon__6YS4s {
  margin-bottom: 11px;
}

.ManagerDashboard_delPopContainer__fuxVD p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
  padding: 0 20px;
}

.ManagerDashboard_arrowback__h5Lwc svg {
  fill: #000;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_arrowback__h5Lwc {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_arrowback__h5Lwc svg {
  fill: #3b82f6;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_drpdwn_btn__RWNOM {
  background-color: #132337;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_empname__GPV-6 {
  color: #92afd3 !important;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_navitemli__SzYbZ a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_tabnavli__kMrh3 a.ManagerDashboard_settingsgeneral__axeic,
.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_tabnavli__kMrh3 a.ManagerDashboard_settingslinks__sMwKi:hover {
  background-color: #3b82f6;
  color: #fff;
}

.ManagerDashboard_bodythemedark__iFTXF .ManagerDashboard_tabnavli__kMrh3 a.ManagerDashboard_settingslinks__sMwKi {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.ManagerDashboard_headerthemedark__484DS .ManagerDashboard_dropdown_menu_contain__INTJM {
  background-color: #1c2e45;
  color: #fff;
}

.ManagerDashboard_headerthemedark__484DS .ManagerDashboard_dropdown_menu_contain__INTJM ul li a,
.ManagerDashboard_headerthemedark__484DS .ManagerDashboard_dropdown_menu_contain__INTJM .ManagerDashboard_dropdown_item__sCNNx,
.ManagerDashboard_headerthemedark__484DS .ManagerDashboard_dropdown_menu_contain__INTJM .ManagerDashboard_dropdown_item__sCNNx h5 {
  color: #fff;
}

.ManagerDashboard_headerthemedark__484DS .ManagerDashboard_dropdown_menu_contain__INTJM ul li a:hover,
.ManagerDashboard_headerthemedark__484DS .ManagerDashboard_dropdown_menu_contain__INTJM .ManagerDashboard_dropdown_item__sCNNx:hover {
  background-color: #132337;
  color: #fff;
}

.ManagerDashboard_dropdown_item__sCNNx:active {
  background-color: #F5F6FA;
}

.ManagerDashboard_profile_arrrow_dwn__XkTwd {
  stroke: #132337;
}

.ManagerDashboard_headerthemedark__484DS .ManagerDashboard_profile_arrrow_dwn__XkTwd {
  stroke: #fff;
}

.ManagerDashboard_dateinputbox1__\\+F-7e input,
.ManagerDashboard_dateinputbox1__\\+F-7e span {
  color: #fff !important;
}

/* LOGOUT MODAL */
.ManagerDashboard_delPopContainer__fuxVD .ManagerDashboard_modal-content__TpXVt {
  border-radius: 10px;
  min-width: 399px;
}

.ManagerDashboard_larg_model__TixdG .ManagerDashboard_modal-dialog__mioIi {
  max-width: 100% !important;
}

.ManagerDashboard_larg_model__TixdG .ManagerDashboard_modal-content__TpXVt {
  /* display: inline-block; */
  height: 100%;
  max-width: 900px;
  margin: auto;
  border-radius: 54px !important;
  background: #FFF;
  padding: 53px 53px 23px;
}

.ManagerDashboard_larg_model__TixdG .ManagerDashboard_modal-header__ulLwz {
  padding: 0px 0px 23px;
  border-bottom: 1px dashed #D4D9EE;
  display: block;
}

body .ManagerDashboard_btn-primary__pNhOe:hover {
  background-color: transparent;
  border-color: #131F43;
  color: #131F43;
  fill: #131F43;
  border: 1px solid;
}

.ManagerDashboard_form-select__oZjY0 {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

thead .ManagerDashboard_CustomTable_tableheadlight__HuHZw__9BhHI th:first-child,
thead .ManagerDashboard_CustomTable_tableheaddark__nwqb4__bttNM th:first-child {
  border-radius: 5px 0 0 0px;
  display: math;
}

th:first-child {
  border-radius: 0px;
  position: absolute;
}

@media only screen and (max-width: 1200px) {
  .ManagerDashboard_tableheadlight__JsZMi th {
    min-width: 270px;
  }
}
@media only screen and (max-width: 1024px) {
  .ManagerDashboard_dashboard__V1Jm8 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
    overflow-x: hidden !important;
  }
  .ManagerDashboard_cont2__\\+vbCD {
    height: auto !important;
    padding-bottom: 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) {
  .ManagerDashboard_sectionright__pBOOG {
    float: unset !important;
  }
  .ManagerDashboard_dashboard__V1Jm8 {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .ManagerDashboard_cont2__\\+vbCD {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px 10px 15px !important;
  }
  .ManagerDashboard_bodythemelight__uo0IO,
.ManagerDashboard_bodythemedark__iFTXF {
    padding-top: 110px;
  }
  .ManagerDashboard_delPopContainer__fuxVD .ManagerDashboard_modal-content__TpXVt {
    min-width: 100%;
  }
  .ManagerDashboard_delPopContainer__fuxVD .ManagerDashboard_modal-body__8LzsZ {
    padding: 15px;
  }
  .ManagerDashboard_larg_model__TixdG .ManagerDashboard_modal-content__TpXVt {
    border-radius: 20px !important;
    padding: 22px;
  }
}
@media (min-width: 576px) {
  .ManagerDashboard_exer_modal_contain__c1maA .ManagerDashboard_modal-dialog__mioIi {
    max-width: 1055px;
  }
  .ManagerDashboard_delPopContainer__fuxVD .ManagerDashboard_modal-dialog__mioIi {
    max-width: 350px;
  }
  /*.tableheadlight th {
    min-width: 120px;
  } */
}
/* vk new changes */
.ManagerDashboard_active_show_outer__T899X h2 {
  color: var(--Font-black, #0B0D0F);
  font-family: Urbanist;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 768px) {
  .ManagerDashboard_active_show_outer__T899X h2 {
    margin-top: 15px;
  }
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx {
  width: 100%;
  display: block;
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_img__hpxRz {
  margin-bottom: 12px;
  min-height: 400px;
  object-fit: cover;
  overflow: hidden;
  height: 400px;
  max-height: 400px;
}
@media (max-width: 767px) {
  .ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_img__hpxRz {
    min-height: 300px;
    height: 300px;
    max-height: 300px;
  }
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_img__hpxRz img {
  max-height: 400px;
  /* align-self: stretch; */
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_cnt__0MIK7 {
  width: 100%;
  display: block;
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_cnt__0MIK7 svg {
  flex-shrink: 0;
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_cnt__0MIK7 .ManagerDashboard_act_box_bdg__x0eTX {
  width: 100%;
  margin-bottom: 12px;
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_cnt__0MIK7 .ManagerDashboard_act_box_bdg__x0eTX span {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right top no-repeat;
  width: 111px;
  display: block;
  height: 34px;
  color: var(--White, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  padding: 3px 8px;
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_cnt__0MIK7 .ManagerDashboard_act_box_bdg__x0eTX .ManagerDashboard_sold__EniWc {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) right top no-repeat !important;
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_cnt__0MIK7 h3 {
  color: var(--Secondary, #132941);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.304px;
  margin: 0;
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_cnt__0MIK7 p {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_cnt__0MIK7 p span {
  color: var(--Light-1, #736B66);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26.304px;
}
.ManagerDashboard_active_show_outer__T899X .ManagerDashboard_active_show_inner__Owgsx .ManagerDashboard_act_box_cnt__0MIK7 p .ManagerDashboard_timezone_code_pill__S-OES {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 4px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 6px;
}

/* vk new changes */
#ManagerDashboard_attent_details_row1__SNPpy {
  margin-bottom: 0 !important;
}

.ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m {
  display: flex;
  gap: 61px;
  padding: 20px;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
  align-items: center;
}
@media (max-width: 576px) {
  .ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m {
    display: block !important;
  }
}
@media (max-width: 992px) {
  .ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m {
    display: flex;
    gap: 20px;
    align-items: start;
  }
}
.ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_l__WrAP5 img {
  width: 187px;
  height: 207px;
  flex-shrink: 0;
  object-fit: cover;
}
.ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT {
  flex: 1 1;
}
.ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT .ManagerDashboard_attent_details_row__0gaIv {
  display: flex;
  gap: 20px;
  margin-bottom: 28px;
}
@media (max-width: 992px) {
  .ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT .ManagerDashboard_attent_details_row__0gaIv {
    margin-bottom: 0px;
    display: inline-block;
    width: 100%;
  }
}
.ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT .ManagerDashboard_attent_details_row__0gaIv .ManagerDashboard_attent_details_row_box__7vOHu {
  flex: 1 1;
  width: 22%;
}
@media (max-width: 576px) {
  .ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT .ManagerDashboard_attent_details_row__0gaIv .ManagerDashboard_attent_details_row_box__7vOHu {
    margin: 15px 0px 10px !important;
    width: 100% !important;
  }
}
@media (max-width: 992px) {
  .ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT .ManagerDashboard_attent_details_row__0gaIv .ManagerDashboard_attent_details_row_box__7vOHu {
    margin-bottom: 15px;
    float: left;
    margin-right: 0;
    width: 50%;
    padding-right: 10px;
  }
}
.ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT .ManagerDashboard_attent_details_row__0gaIv .ManagerDashboard_attent_details_row_box__7vOHu p {
  margin-bottom: 10px;
  color: #727272;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT .ManagerDashboard_attent_details_row__0gaIv .ManagerDashboard_attent_details_row_box__7vOHu h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  word-wrap: break-word;
}
.ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT .ManagerDashboard_attent_details_row_last__0ZSxU {
  margin-bottom: 0px !important;
}
.ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT .ManagerDashboard_attent_details_row_last__0ZSxU.ManagerDashboard_interesting_fact__F8ZXn {
  padding-top: 30px;
}
.ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT .ManagerDashboard_attent_details_row_last__0ZSxU.ManagerDashboard_interesting_fact__F8ZXn .ManagerDashboard_attent_details_row_box__7vOHu {
  width: 100%;
}
.ManagerDashboard_attent_details__axa9w .ManagerDashboard_attent_details_inner__V\\+02m .ManagerDashboard_attent_details_inner_r__rh3iT .ManagerDashboard_attent_details_row_last__0ZSxU.ManagerDashboard_interesting_fact__F8ZXn .ManagerDashboard_attent_details_row_box__7vOHu h5 {
  color: #131F43;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.ManagerDashboard_showbox_sec__xqX9M {
  display: flex;
  justify-content: flex-start;
  gap: 0;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (max-width: 500px) {
  .ManagerDashboard_showbox_sec__xqX9M {
    justify-content: center;
  }
}

.ManagerDashboard_show_box_main__TrXVF {
  margin: 10px 0px;
}
.ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_show_box__2\\+r4u {
  min-height: 600px;
  width: 300px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_show_box__2\\+r4u {
    margin-right: 18px;
  }
}
@media (max-width: 767px) {
  .ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_show_box__2\\+r4u {
    min-height: 500px;
    width: 200px !important;
  }
}
.ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_show_box__2\\+r4u img {
  max-height: 400px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_show_box__2\\+r4u img {
    max-height: 300px !important;
  }
}
.ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_show_box__2\\+r4u:last-child {
  margin-right: 0px !important;
}
.ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_no_show_box__I-b6D {
  width: 350px;
  margin: 0 auto 20px;
  display: block;
}
@media (max-width: 767px) {
  .ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_no_show_box__I-b6D {
    width: 250px !important;
  }
}
.ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_no_show_box__I-b6D img {
  max-height: 450px;
  height: 100%;
  width: 100%;
}
@media (max-width: 767px) {
  .ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_no_show_box__I-b6D img {
    max-height: 350px !important;
  }
}
.ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_no_show_box__I-b6D h6 {
  color: #000;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 20px;
}
@media only screen and (max-width: 600px) {
  .ManagerDashboard_show_box_main__TrXVF .ManagerDashboard_no_show_box__I-b6D h6 {
    font-size: 20px;
  }
}

.ManagerDashboard_attent_flex__ltS6x {
  justify-content: space-between !important;
  gap: 30px;
  align-items: center;
}
.ManagerDashboard_attent_flex__ltS6x h5 {
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
}

/* Breakpoints: 1200px (tablet), 1024px (small tablet), 768px (phone), 576px (large phone), 480px (small phone), 360px (xs) */
.ManagerDashboard_managerDashboardWrap__ye8Tn {
  min-height: calc(100vh - 60px);
  background: transparent;
  font-family: "Lufga", "Inter", system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  color: #242220;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  overflow-x: hidden;
  padding-bottom: env(safe-area-inset-bottom, 0);
}
@media (max-width: 360px) {
  .ManagerDashboard_managerDashboardWrap__ye8Tn {
    -webkit-overflow-scrolling: touch;
  }
}

.ManagerDashboard_container__7WSqw {
  display: flex;
  gap: 42px;
  margin: 0 auto;
  padding: 12px 0 12px 30px;
  position: relative;
  min-width: 0;
}
@media (max-width: 1440px) {
  .ManagerDashboard_container__7WSqw {
    max-width: 100%;
    gap: 32px;
    padding: 12px 20px;
  }
}
@media (max-width: 1200px) {
  .ManagerDashboard_container__7WSqw {
    gap: 28px;
    padding: 12px 20px;
  }
}
@media (max-width: 1024px) {
  .ManagerDashboard_container__7WSqw {
    flex-direction: column;
    gap: 24px;
    padding: 12px 20px;
  }
}
@media (max-width: 768px) {
  .ManagerDashboard_container__7WSqw {
    padding: 12px 16px;
    gap: 20px;
  }
}
@media (max-width: 576px) {
  .ManagerDashboard_container__7WSqw {
    padding: 12px 14px;
    gap: 18px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_container__7WSqw {
    padding: 10px 12px;
    gap: 16px;
  }
}
@media (max-width: 360px) {
  .ManagerDashboard_container__7WSqw {
    padding: 8px 10px;
    gap: 12px;
  }
}

/* ============ SIDE MENU ============ */
.ManagerDashboard_sideMenu__Ip5KN {
  width: 256px;
  min-height: 400px;
  max-height: 1022px;
  position: relative;
  flex-shrink: 0;
}
@media (max-width: 1200px) {
  .ManagerDashboard_sideMenu__Ip5KN {
    width: 220px;
  }
}
@media (max-width: 1024px) {
  .ManagerDashboard_sideMenu__Ip5KN {
    width: 100%;
    min-height: auto;
    max-height: none;
  }
}
@media (max-width: 768px) {
  .ManagerDashboard_sideMenu__Ip5KN {
    width: 100%;
  }
}

.ManagerDashboard_sideMenuBackground__MBl1F {
  position: absolute;
  inset: 0;
  background: white;
  border: 0.8px solid #ececee;
  border-radius: 20px;
  filter: blur(0.5px);
}

.ManagerDashboard_arrowToggle__HoE9C {
  position: absolute;
  left: 238px;
  top: 82px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}
@media (max-width: 1024px) {
  .ManagerDashboard_arrowToggle__HoE9C {
    display: none;
  }
}

.ManagerDashboard_arrow__9Thrq {
  transform: rotate(270deg);
}

.ManagerDashboard_sideMenuContent__twnrp {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: center;
  padding: 34px 0;
  width: 256px;
}
@media (max-width: 1200px) {
  .ManagerDashboard_sideMenuContent__twnrp {
    width: 100%;
  }
}
@media (max-width: 1024px) {
  .ManagerDashboard_sideMenuContent__twnrp {
    width: 100%;
    padding: 24px 0;
    gap: 16px;
  }
}
@media (max-width: 768px) {
  .ManagerDashboard_sideMenuContent__twnrp {
    padding: 20px 0;
    gap: 14px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_sideMenuContent__twnrp {
    padding: 16px 0;
    gap: 12px;
  }
}

/* Profile Header */
.ManagerDashboard_profileHeader__e-OJ9 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 176px;
}
@media (max-width: 1024px) {
  .ManagerDashboard_profileHeader__e-OJ9 {
    width: auto;
    padding: 0 20px;
  }
}

.ManagerDashboard_profilePic__u5IqT {
  position: relative;
  width: 48px;
  height: 48px;
}

.ManagerDashboard_avatarCircle__yLjDJ {
  position: absolute;
  inset: 0;
  width: 48px;
  height: 48px;
  background: radial-gradient(50% 50% at 50% 50%, rgba(205, 71, 243, 0.8) 0%, rgba(205, 71, 243, 0) 100%);
  border-radius: 50%;
}

.ManagerDashboard_avatarImg__yCKnT {
  position: absolute;
  inset: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.ManagerDashboard_profileInfo__6J2Nz {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 116px;
}

.ManagerDashboard_roleText__486Aw {
  font-family: "Lufga", sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(36, 34, 32, 0.4);
  margin: 0;
}

.ManagerDashboard_nameRow__Gccfe {
  display: flex;
  align-items: center;
  gap: 9px;
}

.ManagerDashboard_name__BiJKA {
  font-family: "Lufga", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #242220;
  margin: 0;
  white-space: nowrap;
}

/* Dividers */
.ManagerDashboard_divider__iQKAm {
  width: 100%;
  height: 0.5px;
  opacity: 0.24;
  background: radial-gradient(50% 50% at 50% 50%, rgb(67, 44, 44) 0%, rgba(80, 28, 28, 0) 100%);
}

/* Promo Block */
.ManagerDashboard_promoBlock__ja9hN {
  background: rgba(255, 255, 255, 0.12);
  border: 0.5px solid rgba(245, 239, 235, 0.16);
  border-radius: 28px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 208px;
}
@media (max-width: 1024px) {
  .ManagerDashboard_promoBlock__ja9hN {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }
}
@media (max-width: 768px) {
  .ManagerDashboard_promoBlock__ja9hN {
    border-radius: 20px;
    padding: 14px;
    gap: 16px;
    max-width: 100%;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_promoBlock__ja9hN {
    padding: 12px;
    gap: 14px;
    border-radius: 16px;
  }
}

.ManagerDashboard_promoText__HOeX9 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ManagerDashboard_promoTitle__4fh2K {
  font-family: "Lufga", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.56;
  letter-spacing: 0.16px;
  color: #242220;
  margin: 0;
}
@media (max-width: 768px) {
  .ManagerDashboard_promoTitle__4fh2K {
    font-size: 15px;
  }
}

.ManagerDashboard_promoDescription__6SPGM {
  font-family: "Lufga", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.6;
  color: rgba(36, 34, 32, 0.56);
  margin: 0;
}
@media (max-width: 768px) {
  .ManagerDashboard_promoDescription__6SPGM {
    font-size: 12px;
  }
}

.ManagerDashboard_createEventBtn__4Wxxd {
  background: #cd47f3;
  border: none;
  border-radius: 12px;
  padding: 11px 24px 11px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 48px;
  min-height: 44px; /* Touch target */
  box-shadow: 0px 4px 24px 0px rgba(161, 6, 204, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Lufga", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  color: white;
}
.ManagerDashboard_createEventBtn__4Wxxd:hover {
  background: #b83ad8;
  transform: translateY(-2px);
}
@media (max-width: 768px) {
  .ManagerDashboard_createEventBtn__4Wxxd {
    font-size: 13px;
    height: 44px;
    min-height: 44px;
    padding: 10px 20px 10px 16px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_createEventBtn__4Wxxd {
    font-size: 12px;
    padding: 10px 16px;
  }
}

/* Main Menu */
.ManagerDashboard_mainMenu__psGPC {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.ManagerDashboard_menuTitle__9NjQM {
  padding: 0 20px;
}
.ManagerDashboard_menuTitle__9NjQM p {
  font-family: "Lufga", sans-serif;
  font-size: 11px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(36, 34, 32, 0.4);
  margin: 0;
}

.ManagerDashboard_menuList__ERMLW {
  display: flex;
  flex-direction: column;
  width: 208px;
  margin: 0 auto;
}
@media (max-width: 1200px) {
  .ManagerDashboard_menuList__ERMLW {
    width: 100%;
    max-width: 208px;
  }
}
@media (max-width: 1024px) {
  .ManagerDashboard_menuList__ERMLW {
    width: 100%;
    max-width: 100%;
    padding: 0 20px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_menuList__ERMLW {
    padding: 0 12px;
  }
}

.ManagerDashboard_menuItem__EK-YM {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
}
.ManagerDashboard_menuItem__EK-YM span {
  font-family: "Lufga", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #736b66;
  flex: 1 1;
}
@media (max-width: 768px) {
  .ManagerDashboard_menuItem__EK-YM span {
    font-size: 13px;
  }
}
.ManagerDashboard_menuItem__EK-YM:hover {
  background: rgba(206, 84, 189, 0.05);
}
@media (max-width: 768px) {
  .ManagerDashboard_menuItem__EK-YM {
    padding: 14px 16px;
    gap: 12px;
  }
}

.ManagerDashboard_menuItemActive__O3e\\+7 {
  background: rgba(206, 84, 189, 0.1);
  isolation: isolate;
}
.ManagerDashboard_menuItemActive__O3e\\+7:hover {
  background: rgba(206, 84, 189, 0.1);
}

.ManagerDashboard_activeIndicator__pVdVn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 34px;
  background: #cd47f3;
  border-radius: 30px 0 0 30px;
}

.ManagerDashboard_menuItemActiveText__sAufY {
  color: #cd47f3 !important;
  font-weight: 500 !important;
}

.ManagerDashboard_menuIcon__Hn1lw {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.ManagerDashboard_menuArrow__795Zb {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-left: auto;
}

.ManagerDashboard_menuDivider__-vTBS {
  width: 100%;
  height: 0.5px;
  opacity: 0.24;
  background: radial-gradient(50% 50% at 50% 50%, rgb(67, 44, 44) 0%, rgba(80, 28, 28, 0) 100%);
  margin: 8px 0;
}

.ManagerDashboard_signOutText__LGtug {
  color: red !important;
}

/* ============ MAIN CONTENT ============ */
.ManagerDashboard_mainContent__kMf7D {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 1101px;
  max-width: 100%;
  min-width: 0;
}
@media (max-width: 1024px) {
  .ManagerDashboard_mainContent__kMf7D {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .ManagerDashboard_mainContent__kMf7D {
    gap: 20px;
  }
}

/* Header */
.ManagerDashboard_header__kCLqC {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .ManagerDashboard_header__kCLqC {
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    margin-top: 16px;
  }
}

.ManagerDashboard_headerLeft__xZCQw {
  display: flex;
  align-items: center;
  gap: 13px;
}
@media (max-width: 768px) {
  .ManagerDashboard_headerLeft__xZCQw {
    gap: 10px;
    align-items: flex-start;
    margin-left: -6px;
  }
}

.ManagerDashboard_logo__8T-yS {
  width: 83px;
  height: 83px;
  position: relative;
}
.ManagerDashboard_logo__8T-yS img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
@media (max-width: 768px) {
  .ManagerDashboard_logo__8T-yS {
    width: 60px;
    height: 60px;
  }
}

.ManagerDashboard_welcomeText__xWmKT {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ManagerDashboard_welcomeText__xWmKT h1 {
  font-family: "Lufga", sans-serif;
  font-size: 30px;
  font-weight: 700;
  line-height: 36px;
  color: #111827;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
@media (max-width: 768px) {
  .ManagerDashboard_welcomeText__xWmKT h1 {
    font-size: 22px;
    line-height: 28px;
    white-space: normal;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_welcomeText__xWmKT h1 {
    font-size: 20px;
    line-height: 26px;
  }
}
.ManagerDashboard_welcomeText__xWmKT p {
  font-family: "Lufga", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #4b5563;
  margin: 0;
}
@media (max-width: 768px) {
  .ManagerDashboard_welcomeText__xWmKT p {
    font-size: 14px;
    line-height: 20px;
  }
}

.ManagerDashboard_notification__Z4Z2r {
  position: relative;
  background: #ffffff;
  border: 1px solid #7FA9B8;
  border-radius: 14px;
  width: 42px;
  height: 42px;
  min-width: 42px;
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}
.ManagerDashboard_notification__Z4Z2r svg path {
  fill: #131F43;
}
.ManagerDashboard_notification__Z4Z2r:hover {
  background: #f0e9fd;
  border-color: #9b51e0;
}
@media (max-width: 768px) {
  .ManagerDashboard_notification__Z4Z2r {
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    position: fixed;
    top: max(12px, env(safe-area-inset-top, 0));
    right: max(16px, env(safe-area-inset-right, 0));
    z-index: 9997;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
}
@media (max-width: 360px) {
  .ManagerDashboard_notification__Z4Z2r {
    right: max(10px, env(safe-area-inset-right, 0));
  }
}

.ManagerDashboard_notificationDot__dB6Bq {
  position: absolute;
  top: 5px;
  right: 9px;
  width: 10px;
  height: 10px;
  background: #FF0000;
  border-radius: 50%;
}

/* Stats Cards */
.ManagerDashboard_statsCards__d5\\+3M {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: white;
  border: 0.8px solid #ececee;
  border-radius: 16px;
  min-height: 96px;
  padding: 16px 6px 24px;
  margin-bottom: 32px;
}
@media (max-width: 768px) {
  .ManagerDashboard_statsCards__d5\\+3M {
    min-height: auto;
    padding: 16px 6px;
    margin-bottom: 24px;
  }
}

.ManagerDashboard_statsRow__RkvUH {
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  gap: 0;
  padding: 0;
  z-index: 1;
  width: 100%;
}
@media (max-width: 1200px) {
  .ManagerDashboard_statsRow__RkvUH {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    align-items: stretch;
  }
}
@media (max-width: 768px) {
  .ManagerDashboard_statsRow__RkvUH {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_statsRow__RkvUH {
    gap: 10px;
  }
}
@media (max-width: 360px) {
  .ManagerDashboard_statsRow__RkvUH {
    grid-template-columns: 1fr;
    gap: 8px;
  }
}

.ManagerDashboard_statItem__j6Hcj {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}
@media (max-width: 768px) {
  .ManagerDashboard_statItem__j6Hcj {
    width: auto;
    gap: 10px;
  }
}

.ManagerDashboard_statIcon__let6H {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .ManagerDashboard_statIcon__let6H {
    width: 40px;
    height: 40px;
    padding: 8px;
  }
}

.ManagerDashboard_statIconOrange__s-gBx {
  background: #fff2e9;
}

.ManagerDashboard_statIconPurple__uxCXj {
  background: #ede8ff;
}

.ManagerDashboard_statIconBlue__iW\\+oN {
  background: #eaf9ff;
}

.ManagerDashboard_statIconPink__XU9rT {
  background: #ffebef;
}

.ManagerDashboard_statIconGreen__1a4T8 {
  background: #ebfff8;
}

.ManagerDashboard_statInfo__Y9dpv {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.ManagerDashboard_statLabel__1\\+24K {
  font-family: "Lufga", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #736b66;
  margin: 0;
  line-height: 1.2;
}
@media (max-width: 768px) {
  .ManagerDashboard_statLabel__1\\+24K {
    font-size: 12px;
  }
}

.ManagerDashboard_statValue__JXKhS {
  font-family: "Lufga", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #132941;
  margin: 0;
  line-height: 1.2;
}
@media (max-width: 768px) {
  .ManagerDashboard_statValue__JXKhS {
    font-size: 15px;
  }
}

.ManagerDashboard_statSubtext__hKFjm {
  font-family: "Lufga", sans-serif;
  font-size: 11px;
  font-weight: 400;
  color: #9ca3af;
  margin: 0;
  line-height: 1.2;
}

.ManagerDashboard_statItemContainer__lRcdV {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 768px) {
  .ManagerDashboard_statItemContainer__lRcdV {
    width: auto;
    background: #f8f9fc;
    border-radius: 10px;
    padding: 10px 12px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_statItemContainer__lRcdV {
    padding: 8px 10px;
    border-radius: 8px;
  }
}

/* Separator after each card (hidden only after the last card) */
.ManagerDashboard_statDivider__j064S {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  width: 1px;
  height: 48px;
  opacity: 0.34;
  background: #cbcbcf;
  flex-shrink: 0;
}
@media (max-width: 1200px) {
  .ManagerDashboard_statDivider__j064S {
    display: none;
  }
}

.ManagerDashboard_statsRow__RkvUH .ManagerDashboard_statItemContainer__lRcdV:last-child .ManagerDashboard_statDivider__j064S {
  display: none;
}

/* Desktop: slight padding for Total Revenue and Active Vendors labels */
@media (min-width: 769px) {
  .ManagerDashboard_statsRow__RkvUH .ManagerDashboard_statItemContainer__lRcdV:nth-child(3) .ManagerDashboard_statInfo__Y9dpv,
.ManagerDashboard_statsRow__RkvUH .ManagerDashboard_statItemContainer__lRcdV:nth-child(4) .ManagerDashboard_statInfo__Y9dpv {
    padding-left: 2px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_statsRow__RkvUH .ManagerDashboard_statItemContainer__lRcdV {
    padding: 8px 10px;
    border-radius: 8px;
  }
  .ManagerDashboard_statIcon__let6H {
    width: 36px;
    height: 36px;
    padding: 6px;
  }
  .ManagerDashboard_statLabel__1\\+24K {
    font-size: 11px;
  }
  .ManagerDashboard_statValue__JXKhS {
    font-size: 14px;
  }
}
/* Charts Section */
.ManagerDashboard_chartsSection__T6bL3 {
  display: flex;
  gap: 32px;
  width: 100%;
  min-width: 0;
}
@media (max-width: 1200px) {
  .ManagerDashboard_chartsSection__T6bL3 {
    gap: 24px;
  }
}
@media (max-width: 1024px) {
  .ManagerDashboard_chartsSection__T6bL3 {
    flex-direction: column;
    gap: 24px;
  }
}
@media (max-width: 768px) {
  .ManagerDashboard_chartsSection__T6bL3 {
    gap: 20px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_chartsSection__T6bL3 {
    gap: 16px;
  }
}
@media (max-width: 360px) {
  .ManagerDashboard_chartsSection__T6bL3 {
    gap: 12px;
  }
}

.ManagerDashboard_chartCard__r78si {
  flex: 1 1;
  background: white;
  border: 0.642px solid #ececee;
  border-radius: 16.06px;
  padding: 18px 18px 25px;
  min-width: 0;
  overflow: hidden;
}
@media (max-width: 768px) {
  .ManagerDashboard_chartCard__r78si {
    padding: 16px;
    border-radius: 14px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_chartCard__r78si {
    padding: 14px;
    border-radius: 12px;
  }
}
@media (max-width: 360px) {
  .ManagerDashboard_chartCard__r78si {
    padding: 12px;
  }
}

.ManagerDashboard_chartHeader__xom5w {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 12px;
}
.ManagerDashboard_chartHeader__xom5w h3 {
  font-family: "Lufga", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #111827;
  margin: 0;
  min-width: 0;
}
@media (max-width: 768px) {
  .ManagerDashboard_chartHeader__xom5w h3 {
    font-size: 16px;
    line-height: 24px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_chartHeader__xom5w h3 {
    font-size: 15px;
    line-height: 22px;
  }
}
@media (max-width: 768px) {
  .ManagerDashboard_chartHeader__xom5w {
    margin-bottom: 20px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_chartHeader__xom5w {
    margin-bottom: 16px;
    gap: 10px;
  }
}

.ManagerDashboard_selectWrapper__8sx\\+7 {
  position: relative;
  display: inline-block;
}

.ManagerDashboard_chartSelect__Sfys9 {
  background: white;
  border: 0.642px solid #dbdbdb;
  border-radius: 8px;
  padding: 8.03px 32px 8.03px 8.03px;
  font-family: "Lufga", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: black;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.ManagerDashboard_chartSelect__Sfys9:focus {
  border-color: #cd47f3;
}
@media (max-width: 768px) {
  .ManagerDashboard_chartSelect__Sfys9 {
    font-size: 13px;
    padding: 6px 28px 6px 6px;
  }
}

.ManagerDashboard_selectArrow__9zkxA {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  transition: transform 0.2s ease;
}
@media (max-width: 768px) {
  .ManagerDashboard_selectArrow__9zkxA {
    right: 8px;
  }
  .ManagerDashboard_selectArrow__9zkxA svg {
    width: 10px;
    height: 7px;
  }
}

.ManagerDashboard_chartWrapper__OGutu {
  position: relative;
  width: 100%;
  min-height: 200px;
}
@media (max-width: 768px) {
  .ManagerDashboard_chartWrapper__OGutu {
    min-height: 180px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_chartWrapper__OGutu {
    min-height: 160px;
  }
}

.ManagerDashboard_chartPlaceholder__x9yWf {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 250px;
  background: #f8f9fc;
  border-radius: 12px;
  padding: 40px 20px;
}
@media (max-width: 768px) {
  .ManagerDashboard_chartPlaceholder__x9yWf {
    min-height: 200px;
    padding: 30px 16px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_chartPlaceholder__x9yWf {
    min-height: 180px;
    padding: 24px 12px;
  }
}
@media (max-width: 360px) {
  .ManagerDashboard_chartPlaceholder__x9yWf {
    min-height: 160px;
    padding: 20px 10px;
  }
}

.ManagerDashboard_chartLabel__0Jf6R {
  font-family: "Lufga", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #736b66;
  margin: 0 0 8px 0;
  text-align: center;
}
@media (max-width: 768px) {
  .ManagerDashboard_chartLabel__0Jf6R {
    font-size: 14px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_chartLabel__0Jf6R {
    font-size: 13px;
  }
}

.ManagerDashboard_chartSubtext__fZXe9 {
  font-family: "Lufga", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #92959e;
  margin: 0;
  text-align: center;
}
@media (max-width: 768px) {
  .ManagerDashboard_chartSubtext__fZXe9 {
    font-size: 13px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_chartSubtext__fZXe9 {
    font-size: 12px;
  }
}

/* Quick Actions */
.ManagerDashboard_quickActionsCard__y\\+gK2 {
  flex: 0 0 323px;
  background: white;
  border: 0.642px solid #ececee;
  border-radius: 16.06px;
  padding: 20px 25px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}
@media (max-width: 1200px) {
  .ManagerDashboard_quickActionsCard__y\\+gK2 {
    flex: 1 1 280px;
    min-width: 0;
  }
}
@media (max-width: 1024px) {
  .ManagerDashboard_quickActionsCard__y\\+gK2 {
    flex: 1 1;
  }
}
@media (max-width: 768px) {
  .ManagerDashboard_quickActionsCard__y\\+gK2 {
    padding: 16px;
    border-radius: 14px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_quickActionsCard__y\\+gK2 {
    padding: 14px;
    border-radius: 12px;
  }
}
.ManagerDashboard_quickActionsCard__y\\+gK2 h3 {
  font-family: "Lufga", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #111827;
  margin: 0;
}
@media (max-width: 768px) {
  .ManagerDashboard_quickActionsCard__y\\+gK2 h3 {
    font-size: 16px;
    line-height: 24px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_quickActionsCard__y\\+gK2 h3 {
    font-size: 15px;
    line-height: 22px;
  }
}

.ManagerDashboard_quickActionsList__sL4vH {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
@media (max-width: 480px) {
  .ManagerDashboard_quickActionsList__sL4vH {
    gap: 10px;
  }
}

.ManagerDashboard_quickActionBtn__7u1L2 {
  background: white;
  border: 0.8px solid #ececee;
  border-radius: 12px;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 62px;
  min-height: 44px; /* Min touch target for accessibility */
  cursor: pointer;
  transition: all 0.3s ease;
}
.ManagerDashboard_quickActionBtn__7u1L2 span {
  font-family: "Lufga", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 19.679px;
  color: black;
}
@media (max-width: 768px) {
  .ManagerDashboard_quickActionBtn__7u1L2 span {
    font-size: 13px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_quickActionBtn__7u1L2 span {
    font-size: 12px;
  }
}
.ManagerDashboard_quickActionBtn__7u1L2:hover {
  background: #f8f9fc;
  border-color: #cd47f3;
}
@media (max-width: 768px) {
  .ManagerDashboard_quickActionBtn__7u1L2 {
    height: 56px;
    min-height: 48px;
    padding: 10px 12px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_quickActionBtn__7u1L2 {
    height: 52px;
    min-height: 44px;
    padding: 10px;
  }
}

.ManagerDashboard_actionIcon__CJZKk {
  width: 32px;
  height: 32px;
  border-radius: 6.56px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ManagerDashboard_actionIconBlue__R4Hf- {
  background: rgba(59, 130, 246, 0.1);
}

.ManagerDashboard_actionIconGreen__0qh9y {
  background: rgba(16, 185, 129, 0.1);
}

.ManagerDashboard_actionIconPurple__qiTvZ {
  background: rgba(139, 92, 246, 0.1);
}

.ManagerDashboard_actionIconOrange__9ynm3 {
  background: rgba(245, 158, 11, 0.1);
}

/* Bottom Section */
.ManagerDashboard_bottomSection__0dSZX {
  display: flex;
  gap: 32px;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}
@media (max-width: 1200px) {
  .ManagerDashboard_bottomSection__0dSZX {
    gap: 24px;
  }
}
@media (max-width: 1024px) {
  .ManagerDashboard_bottomSection__0dSZX {
    flex-direction: column;
    gap: 24px;
  }
}
@media (max-width: 768px) {
  .ManagerDashboard_bottomSection__0dSZX {
    gap: 20px;
  }
}
@media (max-width: 576px) {
  .ManagerDashboard_bottomSection__0dSZX {
    gap: 18px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_bottomSection__0dSZX {
    gap: 16px;
  }
}

.ManagerDashboard_revenueTrendCard__dUTcg {
  flex: 1 1;
  min-width: 0;
  background: white;
  border: 0.642px solid #ececee;
  border-radius: 16.06px;
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  overflow: hidden;
}
@media (max-width: 768px) {
  .ManagerDashboard_revenueTrendCard__dUTcg {
    padding: 16px;
    gap: 20px;
    border-radius: 14px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_revenueTrendCard__dUTcg {
    padding: 14px;
    gap: 16px;
    border-radius: 12px;
  }
}

.ManagerDashboard_revenueDivider__JGLf9 {
  width: 100%;
  height: 1px;
  opacity: 0.34;
  background: radial-gradient(50% 50% at 50% 50%, rgb(62, 44, 67) 0%, rgba(68, 28, 80, 0.2) 100%);
}

.ManagerDashboard_revenueFooter__RdYao {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ManagerDashboard_revenueInfo__2DxT- {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.ManagerDashboard_revenueLabel__yuSk4 {
  font-family: "Lufga", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #4b5563;
  margin: 0;
  line-height: normal;
}
@media (max-width: 768px) {
  .ManagerDashboard_revenueLabel__yuSk4 {
    font-size: 13px;
  }
}

.ManagerDashboard_revenueValue__KTZpz {
  font-family: "Lufga", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  line-height: normal;
}
@media (max-width: 768px) {
  .ManagerDashboard_revenueValue__KTZpz {
    font-size: 18px;
  }
}

/* Upcoming Events */
.ManagerDashboard_upcomingEventsCard__ceSdA {
  flex: 1 1;
  min-width: 0;
  background: white;
  border: 0.642px solid #ececee;
  border-radius: 16.06px;
  padding: 25px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: visible;
}
@media (max-width: 768px) {
  .ManagerDashboard_upcomingEventsCard__ceSdA {
    padding: 16px;
    gap: 16px;
  }
}
@media (max-width: 576px) {
  .ManagerDashboard_upcomingEventsCard__ceSdA {
    padding: 14px;
    gap: 14px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_upcomingEventsCard__ceSdA {
    padding: 12px;
    gap: 12px;
  }
}

.ManagerDashboard_eventsHeader__YMun2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  flex-shrink: 0;
}
.ManagerDashboard_eventsHeader__YMun2 h3 {
  font-family: "Lufga", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #111827;
  margin: 0;
  min-width: 0;
}
@media (max-width: 768px) {
  .ManagerDashboard_eventsHeader__YMun2 h3 {
    font-size: 16px;
    line-height: 24px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_eventsHeader__YMun2 h3 {
    font-size: 15px;
  }
}

.ManagerDashboard_viewAllLink__8lT44 {
  font-family: "Lufga", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #cd47f3;
  text-decoration: none;
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 8px 0;
  margin: 0;
  text-align: right;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}
.ManagerDashboard_viewAllLink__8lT44:hover {
  text-decoration: underline;
}
@media (max-width: 480px) {
  .ManagerDashboard_viewAllLink__8lT44 {
    font-size: 13px;
    padding: 6px 0;
  }
}

.ManagerDashboard_eventsList__1c5jT {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 420px;
  padding-bottom: 16px;
}
@media (max-width: 768px) {
  .ManagerDashboard_eventsList__1c5jT {
    max-height: 360px;
    padding-bottom: 20px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_eventsList__1c5jT {
    max-height: 320px;
    gap: 12px;
    padding-bottom: 20px;
  }
}

.ManagerDashboard_eventsLoadingContainer__qhMlW {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
}

.ManagerDashboard_eventsLoadingText__4DqSx {
  text-align: center;
  color: #736b66;
  font-size: 16px;
  font-weight: 400;
  font-family: "Lufga", "Inter", sans-serif;
  margin: 0;
}

.ManagerDashboard_chartLoading__3nn4L {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  text-align: center;
  color: #736b66;
  font-size: 16px;
  font-weight: 400;
  font-family: "Lufga", "Inter", sans-serif;
  margin: 0;
}

/* Section page loader — same typography as global PageLoader; sized for cards (not full viewport) */
.ManagerDashboard_pageLoader__NzME6 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 200px;
  box-sizing: border-box;
}

.ManagerDashboard_pageLoaderText__IKW4S {
  font-family: "Lufga", "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #736b66;
  margin: 0;
  text-align: center;
  line-height: 1.5;
  visibility: visible;
}

.ManagerDashboard_eventCard__l85f1 {
  background: white;
  border: 0.8px solid #ececee;
  border-radius: 20px;
  padding: 13px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  transition: all 0.3s ease;
  min-width: 0;
  overflow: visible;
}
.ManagerDashboard_eventCard__l85f1:hover {
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
}
@media (max-width: 768px) {
  .ManagerDashboard_eventCard__l85f1 {
    padding: 10px;
    gap: 10px;
  }
}
@media (max-width: 576px) {
  .ManagerDashboard_eventCard__l85f1 {
    flex-direction: column;
    align-items: stretch;
    padding: 12px;
    gap: 12px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_eventCard__l85f1 {
    padding: 10px;
    gap: 10px;
  }
}

.ManagerDashboard_eventImage__JlBz6 {
  width: 60px !important;
  height: 107px !important;
  min-width: 60px !important;
  min-height: 107px !important;
  aspect-ratio: 9/16 !important;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .ManagerDashboard_eventImage__JlBz6 {
    width: 52px !important;
    height: 93px !important;
    min-width: 52px !important;
    min-height: 93px !important;
    aspect-ratio: 9/16 !important;
  }
}
@media (max-width: 576px) {
  .ManagerDashboard_eventImage__JlBz6 {
    width: 100% !important;
    min-width: unset !important;
    height: auto !important;
    min-height: unset !important;
    aspect-ratio: 9/16 !important;
    align-self: stretch;
  }
}

.ManagerDashboard_eventDetails__bkhi4 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  overflow: hidden;
}
@media (max-width: 576px) {
  .ManagerDashboard_eventDetails__bkhi4 {
    flex: none;
    width: 100%;
  }
}

.ManagerDashboard_eventTitleRow__Y1FGp {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}
.ManagerDashboard_eventTitleRow__Y1FGp h4 {
  font-family: "Lufga", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #111827;
  margin: 0;
  word-break: break-word;
  overflow-wrap: break-word;
  min-width: 0;
  flex: 1 1 auto;
}
@media (max-width: 768px) {
  .ManagerDashboard_eventTitleRow__Y1FGp h4 {
    font-size: 14px;
    line-height: 20px;
  }
}
@media (max-width: 576px) {
  .ManagerDashboard_eventTitleRow__Y1FGp h4 {
    max-width: 100%;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_eventTitleRow__Y1FGp h4 {
    font-size: 13px;
    line-height: 18px;
  }
}

.ManagerDashboard_badgeLive__lvQNx {
  background: #DCFCE7;
  border-radius: 9999px;
  padding: 2px 12px;
  font-family: "Lufga", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #166534;
  display: inline-block;
  line-height: normal;
  flex-shrink: 0;
}
@media (max-width: 480px) {
  .ManagerDashboard_badgeLive__lvQNx {
    font-size: 11px;
    padding: 2px 10px;
  }
}

.ManagerDashboard_badgeDraft__ELeuG {
  background: #fef3c7;
  border-radius: 9999px;
  padding: 2px 10px;
  font-family: "Lufga", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #92400e;
  display: inline-block;
  line-height: normal;
  flex-shrink: 0;
}
@media (max-width: 480px) {
  .ManagerDashboard_badgeDraft__ELeuG {
    font-size: 11px;
    padding: 2px 8px;
  }
}

.ManagerDashboard_eventDate__gaENv {
  font-family: "Lufga", sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
  color: #4b5563;
  margin: 0;
  word-break: break-word;
  overflow-wrap: break-word;
}
@media (max-width: 768px) {
  .ManagerDashboard_eventDate__gaENv {
    font-size: 12px;
    line-height: 18px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_eventDate__gaENv {
    font-size: 11px;
    line-height: 16px;
  }
}

.ManagerDashboard_eventTickets__Kk16L {
  font-family: "Lufga", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #6b7280;
  margin: 0;
  word-break: break-word;
}
@media (max-width: 480px) {
  .ManagerDashboard_eventTickets__Kk16L {
    font-size: 11px;
  }
}

.ManagerDashboard_eventWarning__Wv7rl {
  font-family: "Lufga", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #ea580c;
  margin: 0;
}

.ManagerDashboard_eventActions__nFx9o {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  flex-basis: 100%;
  justify-content: flex-end;
  align-items: center;
  padding-left: 76px;
  padding-bottom: 4px;
  min-width: 0;
}
@media (max-width: 1200px) {
  .ManagerDashboard_eventActions__nFx9o {
    padding-left: 0;
  }
}
@media (max-width: 768px) {
  .ManagerDashboard_eventActions__nFx9o {
    gap: 10px;
    padding-left: 0;
    padding-bottom: 6px;
  }
}
@media (max-width: 576px) {
  .ManagerDashboard_eventActions__nFx9o {
    flex-basis: auto;
    width: 100%;
    justify-content: flex-start;
    padding-top: 10px;
    padding-bottom: 4px;
    margin-top: 4px;
    border-top: 1px solid #f3f4f6;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_eventActions__nFx9o {
    gap: 8px;
    padding-top: 8px;
    padding-bottom: 4px;
    margin-top: 6px;
  }
}

.ManagerDashboard_eventActionBtn__YSAR9 {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: relative;
  min-width: 44px;
  min-height: 44px;
  touch-action: manipulation;
  /* Show on hover (desktop), focus, and active (touch) */
  /* On mobile: position tooltip below button, scale down with screen size */
}
.ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #1f2937;
  color: #ffffff;
  font-size: 12px;
  font-family: "Lufga", "Inter", sans-serif;
  font-weight: 400;
  line-height: 1.4;
  padding: 6px 10px;
  border-radius: 6px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 9999;
}
.ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]::before {
  content: "";
  position: absolute;
  bottom: calc(100% + 3px);
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1f2937;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 9999;
}
.ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]:hover::after, .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]:hover::before, .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]:focus::after, .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]:focus::before, .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]:focus-visible::after, .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]:focus-visible::before, .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]:active::after, .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]:active::before {
  opacity: 1;
}
@media (max-width: 768px) {
  .ManagerDashboard_eventActionBtn__YSAR9 {
    padding: 6px;
  }
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]::after {
    bottom: auto;
    top: calc(100% + 6px);
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    padding: 6px 10px;
    border-radius: 5px;
  }
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]::before {
    bottom: auto;
    top: calc(100% + 2px);
    left: 50%;
    transform: translateX(-50%);
    border-width: 4px;
    border-top-color: transparent;
    border-bottom-color: #1f2937;
  }
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip][data-tooltip-align=right]::after {
    left: auto;
    right: 0;
    transform: none;
    top: calc(100% + 6px);
  }
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip][data-tooltip-align=right]::before {
    left: auto;
    right: 8px;
    transform: none;
    top: calc(100% + 2px);
    border-top-color: transparent;
    border-bottom-color: #1f2937;
  }
}
@media (max-width: 576px) {
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]::after {
    font-size: 11px;
    padding: 5px 8px;
    border-radius: 4px;
    top: calc(100% + 5px);
  }
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]::before {
    border-width: 4px;
    top: calc(100% + 1px);
  }
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip][data-tooltip-align=right]::after {
    top: calc(100% + 5px);
  }
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip][data-tooltip-align=right]::before {
    top: calc(100% + 1px);
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]::after {
    font-size: 10px;
    padding: 4px 6px;
    border-radius: 4px;
    top: calc(100% + 4px);
  }
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]::before {
    border-width: 3px;
    top: calc(100% + 1px);
  }
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip][data-tooltip-align=right]::after {
    top: calc(100% + 4px);
  }
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip][data-tooltip-align=right]::before {
    top: calc(100% + 1px);
  }
}
@media (max-width: 360px) {
  .ManagerDashboard_eventActionBtn__YSAR9[data-tooltip]::after {
    font-size: 9px;
    padding: 3px 5px;
  }
}
.ManagerDashboard_eventActionBtn__YSAR9[data-tooltip][data-tooltip-align=right]::after {
  left: auto;
  right: 0;
  transform: none;
}
.ManagerDashboard_eventActionBtn__YSAR9[data-tooltip][data-tooltip-align=right]::before {
  left: auto;
  right: 8px;
  transform: none;
}
.ManagerDashboard_eventActionBtn__YSAR9:hover {
  opacity: 0.7;
  transform: scale(1.1);
}
.ManagerDashboard_eventActionBtn__YSAR9:disabled {
  cursor: not-allowed;
  opacity: 0.35;
  transform: none;
}
@media (max-width: 768px) {
  .ManagerDashboard_eventActionBtn__YSAR9 {
    min-width: 40px;
    min-height: 40px;
  }
  .ManagerDashboard_eventActionBtn__YSAR9 svg {
    width: 18px;
    height: 18px;
  }
}

/* Empty State */
.ManagerDashboard_emptyStateCard__Uvtts {
  background: transparent;
  border: none;
  border-radius: 16.06px;
  padding: 60px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}
@media (max-width: 768px) {
  .ManagerDashboard_emptyStateCard__Uvtts {
    padding: 40px 20px;
    min-height: 350px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_emptyStateCard__Uvtts {
    padding: 32px 16px;
    min-height: 300px;
  }
}
@media (max-width: 360px) {
  .ManagerDashboard_emptyStateCard__Uvtts {
    padding: 24px 12px;
    min-height: 260px;
  }
}

.ManagerDashboard_emptyStateContent__tnMDi {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 400px;
}
@media (max-width: 480px) {
  .ManagerDashboard_emptyStateContent__tnMDi {
    max-width: 100%;
  }
}

.ManagerDashboard_emptyStateIcon__bsaBe {
  margin-bottom: 24px;
  animation: ManagerDashboard_fadeInUp__Z9Zvj 0.6s ease-out;
}
.ManagerDashboard_emptyStateIcon__bsaBe svg {
  width: 200px;
  height: auto;
}
@media (max-width: 768px) {
  .ManagerDashboard_emptyStateIcon__bsaBe svg {
    width: 160px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_emptyStateIcon__bsaBe svg {
    width: 120px;
  }
}

.ManagerDashboard_emptyStateTitle__Ghekg {
  font-family: "Lufga", sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
  color: #283340;
  margin: 0px;
}
@media (max-width: 768px) {
  .ManagerDashboard_emptyStateTitle__Ghekg {
    font-size: 18px;
    line-height: 28px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_emptyStateTitle__Ghekg {
    font-size: 16px;
    line-height: 24px;
  }
}

.ManagerDashboard_emptyStateDescription__nYBcd {
  font-family: "Lufga", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #283340;
  margin: 0;
}
@media (max-width: 768px) {
  .ManagerDashboard_emptyStateDescription__nYBcd {
    font-size: 14px;
    line-height: 20px;
  }
}
@media (max-width: 480px) {
  .ManagerDashboard_emptyStateDescription__nYBcd {
    font-size: 13px;
    line-height: 18px;
  }
}

@keyframes ManagerDashboard_fadeInUp__Z9Zvj {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/manager-dashboard/ManagerDashboard.module.scss","webpack://./src/styles/Variables/Variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,gBAAA;EACA,kBAAA;ADtEF;;ACyEA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ADtEF;;ACyEA;;;EAGE,yBApEoB;ADFtB;;ACyEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ADtEF;;ACyEA;;CAAA;AAIA;EACE,wBA1CU;EA2CV,UA1CS;EA2CT,kBAAA;EACA,aAlDiB;EAmDjB,kBAAA;EACA,mBA3HO;EA4HP,+BAAA;EACA,YAAA;EACA,2BAAA;EACA;;;GAAA;ADpEF;;AC0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ADvEF;;AC4EA;EACE,2BAAA;ADzEF;;AC4EA;EACE,yBAAA;EACA,YAAA;ADzEF;;AC6EA;EACE,YAAA;AD1EF;;AC6EA;EACE,sBA9GY;ADoCd;;AC6EA;;CAAA;AAGA;EACE,sBArHY;EAsHZ,iBAAA;AD1EF;;AC6EA;EACE,yBArIgB;EAsIhB,iBAAA;AD1EF;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;;CAAA;AAGA;EACE,sBAtIY;AD4Dd;;AC6EA;EACE,yBArJgB;AD2ElB;;AC6EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;AD1EF;;AC6EA;;CAAA;AAGA;EACE,yBAAA;AD1EF;;AC6EA;EACE,yBA1KgB;ADgGlB;;AC6EA;;CAAA;AAGA;EACE,yBAAA;AD1EF;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;;EAEE,sBAAA;AD1EF;;AC6EA;EACE,yBA5LsB;EA6LtB,cAvMkB;AD6HpB;;AC6EA;EACE,sCAAA;EACA,sBAAA;EACA,oCAAA;AD1EF;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;EACE,sBAAA;EACA,oCAAA;AD1EF;;AC6EA;EACE,0BAAA;AD1EF;;AC6EA;EACE,uBAAA;AD1EF;;AC6EA;EACE,0BAAA;AD1EF;;AC6EA;EACE,uBAAA;AD1EF;;AC6EA;;EAEE,qBAAA;AD1EF;;AC6EA;EACE,yBArOsB;EAsOtB,WA7NY;ADmJd;;AC6EA;;CAAA;AAGA;EACE,cAjOe;ADuJjB;;AC6EA;EACE,cArOe;AD2JjB;;AC6EA;;CAAA;AAGA;EACE,sBA/OY;EAgPZ,YAAA;AD1EF;;AC6EA;EACE,yBA/PgB;EAgQhB,WArPY;EAsPZ,YAAA;AD1EF;;AC6EA;EACE,cAvPe;AD6KjB;;AC6EA;;CAAA;AAGA;EACE,yBA9Sc;EA+Sd,8BAAA;AD1EF;;AC6EA;EACE,WAtQY;AD4Ld;;AC6EA;;EAEE,0BAAA;AD1EF;;AC6EA;;EAEE,0BAAA;AD1EF;;AC6EA;EACE,kBAAA;AD1EF;;AC6EA;EACE,kBAAA;AD1EF;;AC6EA;EACE,oCAAA;EACA,gCAAA;AD1EF;;AC6EA;EACE,yBAzRkB;EA0RlB,WAlSY;ADwNd;;AC6EA;EACE,yBAAA;AD1EF;;AC6EA;EACE,iBAAA;AD1EF;;AC6EA;;EAEE,+BAAA;EACA,iBAAA;AD1EF;;AC6EA;EACE,sBApTY;AD0Od;AC4EE;EACE,sBAvTU;EAwTV,YAAA;AD1EJ;AC4EE;EACA,iBAAA;AD1EF;;AC+EA;EACE,0CAAA;EACA,cA/Te;ADmPjB;AC8EE;EACE,yCAAA;EACA,eAAA;AD5EJ;;ACgFA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AD7EF;;ACgFA;EACE,yBAAA;EACA,0BAAA;AD7EF;;ACgFA;;CAAA;AAGA;EACE,sBA3VY;EA4VZ,yBAAA;EACA,qDAAA;AD7EF;;ACgFA;EACE,yBAzVkB;EA0VlB,yBAAA;EACA,eAAA;AD7EF;AC+EE;EACE,cAnWa;ADsRjB;;ACkFA;;CAAA;AAGA;EACE,yBAlXgB;ADmSlB;;ACkFA;EACE,yBAAA;EACA,yBAAA;AD/EF;;ACkFA;EACE,yBAlYoB;EAmYpB,yBAAA;AD/EF;;ACkFA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AD/EF;;ACkFA;;CAAA;AAGA;EACE,sBAtYY;ADuTd;;ACkFA;EACE,yBAlYkB;ADmTpB;;ACmFA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAnZY;ADmUd;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;EACE,gGAAA;EACA,sBA5ZY;AD4Ud;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;EACE,gGAAA;EACA,sBAraY;ADqVd;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;EACE,gGAAA;EACA,sBA9aY;AD8Vd;;ACmFA;EACE,mBAAA;ADhFF;;ACmFA;;;;;;;;EAQE,WA7bY;AD6Wd;;ACmFA;;CAAA;AAGA;EACE,qCAAA;ADhFF;;ACmFA;EACE,cArce;ADqXjB;;ACoFA;;CAAA;AAGA;EACE,sBAAA;ADjFF;;ACoFA;EACE,yBAAA;ADjFF;;ACoFA;EACE,yBAzekB;EA0elB,WAzdY;ADwYd;;ACoFA;EACE,yBA9ekB;EA+elB,WA9dY;AD6Yd;;ACoFA;EACE,6BAAA;ADjFF;;ACoFA;EACE,2BAAA;ADjFF;;ACoFA;EACE,yBA3fkB;AD0apB;;ACoFA;EACE,yBA9fwB;AD6a1B;;ACoFA;EACE,WAlfY;EAmfZ,6BAAA;EACA,yBAAA;ADjFF;;ACoFA;EACE,yBAzgBkB;ADwbpB;;ACqFA;EACE,yBAxgBgB;ADsblB;;ACqFA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,2BAAA;ADlFF;;ACqFA;;;EAGE,oCAAA;EACA,sBAAA;ADlFF;;ACqFA;EACE,gBAAA;EACA,YAAA;EACA,WAphBY;EAqhBZ,yBAhjBY;EAijBZ,YAAA;EACA,eAAA;EACA,gBA3kBc;ADyfhB;;ACqFA;EACE,gBAAA;EACA,YAAA;EACA,WA9hBY;EA+hBZ,yBA1jBY;EA2jBZ,YAAA;EACA,eAAA;EACA,gBArlBc;ADmgBhB;;ACqFA;EACE,yBAjkBY;AD+ed;;ACqFA;EACE,yBA3jBkB;ADyepB;;ACqFA;EACE,yBA9jBwB;AD4e1B;;ACqFA;EACE,cApkBiB;ADkfnB;;ACsFA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ADnFF;;ACsFA;EACE,WA7jBY;EA8jBZ,yBAzlBY;EA0lBZ,YAAA;ADnFF;;ACsFA;EACE,QAAA;ADnFF;;ACsFA;EACE,gBAAA;EACA,YAAA;EACA,yBA7lBW;EA8lBX,WA1kBY;EA2kBZ,eAAA;EACA,gBA/nBc;EAgoBd,YAAA;ADnFF;;ACsFA;EACE,gBAAA;EACA,YAAA;EACA,yBAvmBW;EAwmBX,WAplBY;EAqlBZ,eAAA;EACA,gBAzoBc;EA0oBd,YAAA;ADnFF;;ACsFA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;ADnFF;;ACsFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ADnFF;;ACsFA;;;EAGE,yBA9nBW;EA+nBX,WA3mBY;EA4mBZ,YAAA;ADnFF;;ACsFA;EACE,oCAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ADnFF;;ACsFA;;;EAGE,oCAAA;ADnFF;;ACsFA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ADnFF;;ACwFA;EACE,aAAA;EACA,kBAAA;ADrFF;;ACwFA;EACE,mBAAA;ADrFF;;ACwFA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ADrFF;;ACwFA;EACE,UAAA;ADrFF;;ACwFA;EACE,yCA3qBc;EA4qBd,cAhrBkB;AD2lBpB;;ACwFA;EACE,aAprBkB;AD+lBpB;;ACwFA;EACE,yBAhrBgB;AD2lBlB;;ACwFA;EACE,yBAAA;ADrFF;;ACwFA;EACE,6BAAA;EACA,yBAAA;EACA,WA/qBY;AD0lBd;;ACwFA;;EAEE,yBArsBkB;EAssBlB,WArrBY;ADgmBd;;ACwFA;EACE,6BAAA;EACA,yBAAA;EACA,WA3rBY;ADsmBd;;ACwFA;EACE,yBAxsBsB;EAysBtB,WAhsBY;AD2mBd;;ACwFA;;;EAGE,WAtsBY;ADinBd;;ACwFA;;EAEE,yBAttBgB;EAutBhB,WA5sBY;ADunBd;;ACwFA;EACE,yBA9vBO;ADyqBT;;ACwFA;EACE,eA/tBgB;AD0oBlB;;ACwFA;EACE,YAxtBY;ADmoBd;;ACwFA;;EAEE,sBAAA;ADrFF;;ACwFA,iBAAA;AAKA;EACE,mBAAA;EACA,gBAAA;ADzFF;;AC4FA;EACE,0BAAA;ADzFF;;AC4FA;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;ADzFF;;AC4FA;EACE,qBAAA;EACA,iCAAA;EACA,cAAA;ADzFF;;AC4FA;EACE,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;ADzFF;;AC4FA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,oEAAA;ADzFF;;AC4FA;;EAEE,0BAAA;EACA,aAAA;ADzFF;;AC4FA;EACE,kBAAA;EACA,kBAAA;ADzFF;;AC4FA;EACE;IACE,gBAAA;EDzFF;AACF;AC4FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ED1FF;EC6FA;IACE,uBAAA;IACA,+BAAA;ED3FF;AACF;AC8FA;EACE;;IAAA;AD1FF;AC+FA;EACE;IACE,uBAAA;ED7FF;ECgGA;IACE,6BAAA;ED9FF;AACF;ACiGA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,kCAAA;ED/FF;ECkGA;;IAEE,kBAAA;EDhGF;ECmGA;IACE,eAAA;EDjGF;ECoGA;IACE,aAAA;EDlGF;ECqGA;IACE,8BAAA;IACA,aAAA;EDnGF;AACF;ACsGA;EACE;IACE,iBAAA;EDpGF;ECuGA;IACE,gBAAA;EDrGF;ECwGA;;KAAA;ADpGF;ACyGA,mBAAA;AAGE;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADzGJ;AC0GI;EAPF;IAQI,gBAAA;EDvGJ;AACF;AC0GE;EACE,WAAA;EACA,cAAA;ADxGJ;AC0GI;EACE,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;ADxGN;ACyGM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,iBAAA;EDtGN;AACF;ACuGM;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ADrGR;ACyGI;EACE,WAAA;EACA,cAAA;ADvGN;ACwGA;EACE,cAAA;ADtGF;ACwGM;EACE,WAAA;EACA,mBAAA;ADtGR;ACwGQ;EACE,uEAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ADtGV;ACyGQ;EACE,kFAAA;ADvGV;AC4GM;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AD1GR;AC6GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AD3GR;AC6GQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AD3GV;AC8GQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AD5GV;;ACmHA,mBAAA;AACA;EACI,2BAAA;ADhHJ;;ACmHE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;ADhHJ;ACkHI;EATF;IAUI,yBAAA;ED/GJ;AACF;ACiHI;EAbF;IAcI,aAAA;IACA,SAAA;IACA,kBAAA;ED9GJ;AACF;ACiHM;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AD/GR;ACmHI;EACE,SAAA;ADjHN;ACmHM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ADjHR;ACmHQ;EALF;IAMI,kBAAA;IACA,qBAAA;IACA,WAAA;EDhHR;AACF;ACkHQ;EACE,SAAA;EACA,UAAA;ADhHV;ACkHU;EAJF;IAKI,gCAAA;IACA,sBAAA;ED/GV;AACF;ACiHU;EATF;IAUI,mBAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;ED9GV;AACF;ACgHU;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AD9GZ;ACiHU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AD/GZ;ACoHM;EACE,6BAAA;ADlHR;ACmHQ;EACE,iBAAA;ADjHV;ACkHU;EACE,WAAA;ADhHZ;ACiHY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AD/Gd;;ACwHC;EACK,aAAA;EACF,2BAAA;EACA,MAAA;EACA,mBAAA;EACA,eAAA;ADrHJ;ACsHI;EANH;IAOK,uBAAA;EDnHJ;AACF;;ACqHA;EACE,gBAAA;ADlHF;ACoHE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ADlHJ;ACoHI;EARF;IASI,kBAAA;EDjHJ;AACF;ACkHI;EAXF;IAYI,iBAAA;IACA,uBAAA;ED/GJ;AACF;ACiHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AD/GN;ACiHM;EALF;IAMI,4BAAA;ED9GN;AACF;ACiHI;EACE,4BAAA;AD/GN;ACmHE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;ADjHJ;ACmHI;EALF;IAMI,uBAAA;EDhHJ;AACF;ACkHI;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ADhHN;ACkHM;EALF;IAMI,4BAAA;ED/GN;AACF;ACiHI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AD/GN;ACgHM;EARF;IASI,eAAA;ED7GN;AACF;;ACoHA;EACE,yCAAA;EACA,SAAA;EACA,mBAAA;ADjHF;ACmHE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;ADjHJ;;AA3lCA,6HAAA;AAEA;EACE,8BAAA;EACA,uBAAA;EACA,qFAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,8CAAA;AA6lCF;AA3lCE;EAZF;IAaI,iCAAA;EA8lCF;AACF;;AA3lCA;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AA8lCF;AA5lCE;EARF;IASI,eAAA;IACA,SAAA;IACA,kBAAA;EA+lCF;AACF;AA7lCE;EAdF;IAeI,SAAA;IACA,kBAAA;EAgmCF;AACF;AA9lCE;EAnBF;IAoBI,sBAAA;IACA,SAAA;IACA,kBAAA;EAimCF;AACF;AA/lCE;EAzBF;IA0BI,kBAAA;IACA,SAAA;EAkmCF;AACF;AAhmCE;EA9BF;IA+BI,kBAAA;IACA,SAAA;EAmmCF;AACF;AAjmCE;EAnCF;IAoCI,kBAAA;IACA,SAAA;EAomCF;AACF;AAlmCE;EAxCF;IAyCI,iBAAA;IACA,SAAA;EAqmCF;AACF;;AAlmCA,wCAAA;AACA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAqmCF;AAnmCE;EAPF;IAQI,YAAA;EAsmCF;AACF;AApmCE;EAXF;IAYI,WAAA;IACA,gBAAA;IACA,gBAAA;EAumCF;AACF;AArmCE;EAjBF;IAkBI,WAAA;EAwmCF;AACF;;AArmCA;EACE,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AAwmCF;;AArmCA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AAwmCF;AAtmCE;EAZF;IAaI,aAAA;EAymCF;AACF;;AAtmCA;EACE,yBAAA;AAymCF;;AAtmCA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAymCF;AAvmCE;EATF;IAUI,WAAA;EA0mCF;AACF;AAxmCE;EAbF;IAcI,WAAA;IACA,eAAA;IACA,SAAA;EA2mCF;AACF;AAzmCE;EAnBF;IAoBI,eAAA;IACA,SAAA;EA4mCF;AACF;AA1mCE;EAxBF;IAyBI,eAAA;IACA,SAAA;EA6mCF;AACF;;AA1mCA,mBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AA6mCF;AA3mCE;EANF;IAOI,WAAA;IACA,eAAA;EA8mCF;AACF;;AA3mCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AA8mCF;;AA3mCA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uGAAA;EACA,kBAAA;AA8mCF;;AA3mCA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA8mCF;;AA3mCA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,YAAA;AA8mCF;;AA3mCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,4BAAA;EACA,SAAA;AA8mCF;;AA3mCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA8mCF;;AA3mCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;AA8mCF;;AA3mCA,aAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,6FAAA;AA8mCF;;AA3mCA,gBAAA;AACA;EACE,qCAAA;EACA,6CAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AA8mCF;AA5mCE;EAVF;IAWI,WAAA;IACA,gBAAA;IACA,cAAA;EA+mCF;AACF;AA7mCE;EAhBF;IAiBI,mBAAA;IACA,aAAA;IACA,SAAA;IACA,eAAA;EAgnCF;AACF;AA9mCE;EAvBF;IAwBI,aAAA;IACA,SAAA;IACA,mBAAA;EAinCF;AACF;;AA9mCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAinCF;;AA9mCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AAinCF;AA/mCE;EATF;IAUI,eAAA;EAknCF;AACF;;AA/mCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;AAknCF;AAhnCE;EARF;IASI,eAAA;EAmnCF;AACF;;AAhnCA;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA,EAAA,iBAAA;EACA,mDAAA;EACA,eAAA;EACA,yBAAA;EAEA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAknCF;AAhnCE;EACE,mBAAA;EACA,2BAAA;AAknCJ;AA/mCE;EA1BF;IA2BI,eAAA;IACA,YAAA;IACA,gBAAA;IACA,4BAAA;EAknCF;AACF;AAhnCE;EAjCF;IAkCI,eAAA;IACA,kBAAA;EAmnCF;AACF;;AAhnCA,cAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AAmnCF;;AAhnCA;EACE,eAAA;AAmnCF;AAjnCE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,4BAAA;EACA,SAAA;AAmnCJ;;AA/mCA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAknCF;AAhnCE;EANF;IAOI,WAAA;IACA,gBAAA;EAmnCF;AACF;AAjnCE;EAXF;IAYI,WAAA;IACA,eAAA;IACA,eAAA;EAonCF;AACF;AAlnCE;EAjBF;IAkBI,eAAA;EAqnCF;AACF;;AAlnCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAqnCF;AAnnCE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAqnCJ;AAnnCI;EARF;IASI,eAAA;EAsnCJ;AACF;AAnnCE;EACE,oCAAA;AAqnCJ;AAlnCE;EA3BF;IA4BI,kBAAA;IACA,SAAA;EAqnCF;AACF;;AAlnCA;EACE,mCAAA;EACA,kBAAA;AAqnCF;AAnnCE;EACE,mCAAA;AAqnCJ;;AAjnCA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;AAonCF;;AAjnCA;EACE,yBAAA;EACA,2BAAA;AAonCF;;AAjnCA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAonCF;;AAjnCA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAonCF;;AAjnCA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,6FAAA;EACA,aAAA;AAonCF;;AAjnCA;EACE,qBAAA;AAonCF;;AAjnCA,2CAAA;AACA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;AAonCF;AAlnCE;EATF;IAUI,WAAA;EAqnCF;AACF;AAnnCE;EAbF;IAcI,SAAA;EAsnCF;AACF;;AAnnCA,WAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAsnCF;AApnCE;EALF;IAMI,sBAAA;IACA,SAAA;IACA,uBAAA;IACA,gBAAA;EAunCF;AACF;;AApnCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAunCF;AArnCE;EALF;IAMI,SAAA;IACA,uBAAA;IACA,iBAAA;EAwnCF;AACF;;AArnCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAwnCF;AAtnCE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAwnCJ;AArnCE;EAXF;IAYI,WAAA;IACA,YAAA;EAwnCF;AACF;;AArnCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAwnCF;AAtnCE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAwnCJ;AAtnCI;EAZF;IAaI,eAAA;IACA,iBAAA;IACA,mBAAA;EAynCJ;AACF;AAvnCI;EAlBF;IAmBI,eAAA;IACA,iBAAA;EA0nCJ;AACF;AAvnCE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAynCJ;AAvnCI;EARF;IASI,eAAA;IACA,iBAAA;EA0nCJ;AACF;;AAtnCA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AAynCF;AAvnCE;EACE,aAAA;AAynCJ;AAtnCE;EACE,mBAAA;EACA,qBAAA;AAwnCJ;AArnCE;EAzBF;IA0BI,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;IACA,2CAAA;IACA,+CAAA;IACA,aAAA;IACA,yCAAA;EAwnCF;AACF;AAtnCE;EArCF;IAsCI,+CAAA;EAynCF;AACF;;AAtnCA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAynCF;;AAtnCA,gBAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AAynCF;AAvnCE;EAbF;IAcI,gBAAA;IACA,iBAAA;IACA,mBAAA;EA0nCF;AACF;;AAvnCA;EACE,kBAAA;EACA,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AA0nCF;AAxnCE;EAVF;IAWI,qCAAA;IACA,SAAA;IACA,oBAAA;EA2nCF;AACF;AAznCE;EAhBF;IAiBI,qCAAA;IACA,SAAA;EA4nCF;AACF;AA1nCE;EArBF;IAsBI,SAAA;EA6nCF;AACF;AA3nCE;EAzBF;IA0BI,0BAAA;IACA,QAAA;EA8nCF;AACF;;AA3nCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA8nCF;AA5nCE;EANF;IAOI,WAAA;IACA,SAAA;EA+nCF;AACF;;AA5nCA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;AA+nCF;AA7nCE;EAVF;IAWI,WAAA;IACA,YAAA;IACA,YAAA;EAgoCF;AACF;;AA7nCA;EACE,mBAAA;AAgoCF;;AA7nCA;EACE,mBAAA;AAgoCF;;AA7nCA;EACE,mBAAA;AAgoCF;;AA7nCA;EACE,mBAAA;AAgoCF;;AA7nCA;EACE,mBAAA;AAgoCF;;AA7nCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAgoCF;;AA7nCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAgoCF;AA9nCE;EARF;IASI,eAAA;EAioCF;AACF;;AA9nCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAioCF;AA/nCE;EARF;IASI,eAAA;EAkoCF;AACF;;AA/nCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAkoCF;;AA/nCA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAkoCF;AAhoCE;EANF;IAOI,WAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EAmoCF;AACF;AAjoCE;EAbF;IAcI,iBAAA;IACA,kBAAA;EAooCF;AACF;;AAjoCA,gEAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAooCF;AAloCE;EAXF;IAYI,aAAA;EAqoCF;AACF;;AAloCA;EACE,aAAA;AAqoCF;;AAloCA,wEAAA;AACA;EACE;;IAEE,iBAAA;EAqoCF;AACF;AAloCA;EACE;IACE,iBAAA;IACA,kBAAA;EAooCF;EAjoCA;IACE,WAAA;IACA,YAAA;IACA,YAAA;EAmoCF;EAhoCA;IACE,eAAA;EAkoCF;EA/nCA;IACE,eAAA;EAioCF;AACF;AA9nCA,mBAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAgoCF;AA9nCE;EANF;IAOI,SAAA;EAioCF;AACF;AA/nCE;EAVF;IAWI,sBAAA;IACA,SAAA;EAkoCF;AACF;AAhoCE;EAfF;IAgBI,SAAA;EAmoCF;AACF;AAjoCE;EAnBF;IAoBI,SAAA;EAooCF;AACF;AAloCE;EAvBF;IAwBI,SAAA;EAqoCF;AACF;;AAloCA;EACE,SAAA;EACA,iBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAqoCF;AAnoCE;EATF;IAUI,aAAA;IACA,mBAAA;EAsoCF;AACF;AApoCE;EAdF;IAeI,aAAA;IACA,mBAAA;EAuoCF;AACF;AAroCE;EAnBF;IAoBI,aAAA;EAwoCF;AACF;;AAroCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAwoCF;AAtoCE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AAwoCJ;AAtoCI;EATF;IAUI,eAAA;IACA,iBAAA;EAyoCJ;AACF;AAvoCI;EAdF;IAeI,eAAA;IACA,iBAAA;EA0oCJ;AACF;AAvoCE;EA5BF;IA6BI,mBAAA;EA0oCF;AACF;AAxoCE;EAhCF;IAiCI,mBAAA;IACA,SAAA;EA2oCF;AACF;;AAxoCA;EACE,kBAAA;EACA,qBAAA;AA2oCF;;AAxoCA;EACE,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AA2oCF;AAzoCE;EACE,qBAAA;AA2oCJ;AAxoCE;EAnBF;IAoBI,eAAA;IACA,yBAAA;EA2oCF;AACF;;AAxoCA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,+BAAA;AA2oCF;AAzoCE;EARF;IASI,UAAA;EA4oCF;EA1oCE;IACE,WAAA;IACA,WAAA;EA4oCJ;AACF;;AAxoCA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;AA2oCF;AAzoCE;EALF;IAMI,iBAAA;EA4oCF;AACF;AA1oCE;EATF;IAUI,iBAAA;EA6oCF;AACF;;AA1oCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA6oCF;AA3oCE;EAVF;IAWI,iBAAA;IACA,kBAAA;EA8oCF;AACF;AA5oCE;EAfF;IAgBI,iBAAA;IACA,kBAAA;EA+oCF;AACF;AA7oCE;EApBF;IAqBI,iBAAA;IACA,kBAAA;EAgpCF;AACF;;AA7oCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAgpCF;AA9oCE;EARF;IASI,eAAA;EAipCF;AACF;AA/oCE;EAZF;IAaI,eAAA;EAkpCF;AACF;;AA/oCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAkpCF;AAhpCE;EARF;IASI,eAAA;EAmpCF;AACF;AAjpCE;EAZF;IAaI,eAAA;EAopCF;AACF;;AAjpCA,kBAAA;AACA;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAopCF;AAlpCE;EAXF;IAYI,eAAA;IACA,YAAA;EAqpCF;AACF;AAnpCE;EAhBF;IAiBI,SAAA;EAspCF;AACF;AAppCE;EApBF;IAqBI,aAAA;IACA,mBAAA;EAupCF;AACF;AArpCE;EAzBF;IA0BI,aAAA;IACA,mBAAA;EAwpCF;AACF;AAtpCE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAwpCJ;AAtpCI;EARF;IASI,eAAA;IACA,iBAAA;EAypCJ;AACF;AAvpCI;EAbF;IAcI,eAAA;IACA,iBAAA;EA0pCJ;AACF;;AAtpCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAypCF;AAvpCE;EALF;IAMI,SAAA;EA0pCF;AACF;;AAvpCA;EACE,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA,EAAA,uCAAA;EACA,eAAA;EACA,yBAAA;AA0pCF;AAxpCE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AA0pCJ;AAxpCI;EAPF;IAQI,eAAA;EA2pCJ;AACF;AAzpCI;EAXF;IAYI,eAAA;EA4pCJ;AACF;AAzpCE;EACE,mBAAA;EACA,qBAAA;AA2pCJ;AAxpCE;EAlCF;IAmCI,YAAA;IACA,gBAAA;IACA,kBAAA;EA2pCF;AACF;AAzpCE;EAxCF;IAyCI,YAAA;IACA,gBAAA;IACA,aAAA;EA4pCF;AACF;;AAzpCA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA4pCF;;AAzpCA;EACE,mCAAA;AA4pCF;;AAzpCA;EACE,mCAAA;AA4pCF;;AAzpCA;EACE,mCAAA;AA4pCF;;AAzpCA;EACE,mCAAA;AA4pCF;;AAzpCA,mBAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA4pCF;AA1pCE;EAPF;IAQI,SAAA;EA6pCF;AACF;AA3pCE;EAXF;IAYI,sBAAA;IACA,SAAA;EA8pCF;AACF;AA5pCE;EAhBF;IAiBI,SAAA;EA+pCF;AACF;AA7pCE;EApBF;IAqBI,SAAA;EAgqCF;AACF;AA9pCE;EAxBF;IAyBI,SAAA;EAiqCF;AACF;;AA9pCA;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAiqCF;AA/pCE;EAZF;IAaI,aAAA;IACA,SAAA;IACA,mBAAA;EAkqCF;AACF;AAhqCE;EAlBF;IAmBI,aAAA;IACA,SAAA;IACA,mBAAA;EAmqCF;AACF;;AAhqCA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,+FAAA;AAmqCF;;AAhqCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAmqCF;;AAhqCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAmqCF;;AAhqCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;AAmqCF;AAjqCE;EARF;IASI,eAAA;EAoqCF;AACF;;AAjqCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;AAoqCF;AAlqCE;EARF;IASI,eAAA;EAqqCF;AACF;;AAlqCA,oBAAA;AACA;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AAqqCF;AAnqCE;EAZF;IAaI,aAAA;IACA,SAAA;EAsqCF;AACF;AApqCE;EAjBF;IAkBI,aAAA;IACA,SAAA;EAuqCF;AACF;AArqCE;EAtBF;IAuBI,aAAA;IACA,SAAA;EAwqCF;AACF;;AArqCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;AAwqCF;AAtqCE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AAwqCJ;AAtqCI;EATF;IAUI,eAAA;IACA,iBAAA;EAyqCJ;AACF;AAvqCI;EAdF;IAeI,eAAA;EA0qCJ;AACF;;AAtqCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;AAyqCF;AAvqCE;EACE,0BAAA;AAyqCJ;AAtqCE;EAtBF;IAuBI,eAAA;IACA,cAAA;EAyqCF;AACF;;AAtqCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAyqCF;AAvqCE;EAVF;IAWI,iBAAA;IACA,oBAAA;EA0qCF;AACF;AAxqCE;EAfF;IAgBI,iBAAA;IACA,SAAA;IACA,oBAAA;EA2qCF;AACF;;AAxqCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AA2qCF;;AAxqCA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,SAAA;AA2qCF;;AAxqCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,SAAA;AA2qCF;;AAxqCA,oGAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AA2qCF;;AAxqCA;EACE,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA2qCF;;AAxqCA;EACE,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;AA2qCF;AAzqCE;EACE,gDAAA;AA2qCJ;AAxqCE;EAjBF;IAkBI,aAAA;IACA,SAAA;EA2qCF;AACF;AAzqCE;EAtBF;IAuBI,sBAAA;IACA,oBAAA;IACA,aAAA;IACA,SAAA;EA4qCF;AACF;AA1qCE;EA7BF;IA8BI,aAAA;IACA,SAAA;EA6qCF;AACF;;AA1qCA;EACE,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AA6qCF;AA3qCE;EAVF;IAWI,sBAAA;IACA,uBAAA;IACA,0BAAA;IACA,2BAAA;IACA,6BAAA;EA8qCF;AACF;AA5qCE;EAlBF;IAmBI,sBAAA;IACA,2BAAA;IACA,uBAAA;IACA,4BAAA;IACA,6BAAA;IACA,mBAAA;EA+qCF;AACF;;AA5qCA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AA+qCF;AA7qCE;EARF;IASI,UAAA;IACA,WAAA;EAgrCF;AACF;;AA7qCA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;AAgrCF;AA9qCE;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;AAgrCJ;AA9qCI;EAZF;IAaI,eAAA;IACA,iBAAA;EAirCJ;AACF;AA/qCI;EAjBF;IAkBI,eAAA;EAkrCJ;AACF;AAhrCI;EArBF;IAsBI,eAAA;IACA,iBAAA;EAmrCJ;AACF;;AA/qCA;EACE,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;AAkrCF;AAhrCE;EAZF;IAaI,eAAA;IACA,iBAAA;EAmrCF;AACF;;AAhrCA;EACE,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;AAmrCF;AAjrCE;EAZF;IAaI,eAAA;IACA,gBAAA;EAorCF;AACF;;AAjrCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;AAorCF;AAlrCE;EAVF;IAWI,eAAA;IACA,iBAAA;EAqrCF;AACF;AAnrCE;EAfF;IAgBI,eAAA;IACA,iBAAA;EAsrCF;AACF;;AAnrCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;AAsrCF;AAprCE;EATF;IAUI,eAAA;EAurCF;AACF;;AAprCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAurCF;;AAprCA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAurCF;AArrCE;EAXF;IAYI,eAAA;EAwrCF;AACF;AAtrCE;EAfF;IAgBI,SAAA;IACA,eAAA;IACA,mBAAA;EAyrCF;AACF;AAvrCE;EArBF;IAsBI,gBAAA;IACA,WAAA;IACA,2BAAA;IACA,iBAAA;IACA,mBAAA;IACA,eAAA;IACA,6BAAA;EA0rCF;AACF;AAxrCE;EA/BF;IAgCI,QAAA;IACA,gBAAA;IACA,mBAAA;IACA,eAAA;EA2rCF;AACF;;AAxrCA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EAqCA,uDAAA;EAYA,0EAAA;AA4oCF;AA3rCE;EACE,2BAAA;EACA,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,8BAAA;EACA,aAAA;AA6rCJ;AA1rCE;EACE,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,yBAAA;EACA,oBAAA;EACA,UAAA;EACA,8BAAA;EACA,aAAA;AA4rCJ;AAxrCE;EAQE,UAAA;AAmrCJ;AA/qCE;EA9DF;IA+DI,YAAA;EAkrCF;EAhrCE;IACE,YAAA;IACA,qBAAA;IACA,SAAA;IACA,2BAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;EAkrCJ;EA/qCE;IACE,YAAA;IACA,qBAAA;IACA,SAAA;IACA,2BAAA;IACA,iBAAA;IACA,6BAAA;IACA,4BAAA;EAirCJ;EA9qCE;IACE,UAAA;IACA,QAAA;IACA,eAAA;IACA,qBAAA;EAgrCJ;EA7qCE;IACE,UAAA;IACA,UAAA;IACA,eAAA;IACA,qBAAA;IACA,6BAAA;IACA,4BAAA;EA+qCJ;AACF;AA5qCE;EACE;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,qBAAA;EA8qCJ;EA3qCE;IACE,iBAAA;IACA,qBAAA;EA6qCJ;EA1qCE;IACE,qBAAA;EA4qCJ;EAzqCE;IACE,qBAAA;EA2qCJ;AACF;AAxqCE;EACE;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,qBAAA;EA0qCJ;EAvqCE;IACE,iBAAA;IACA,qBAAA;EAyqCJ;EAtqCE;IACE,qBAAA;EAwqCJ;EArqCE;IACE,qBAAA;EAuqCJ;AACF;AApqCE;EACE;IACE,cAAA;IACA,gBAAA;EAsqCJ;AACF;AAnqCE;EACE,UAAA;EACA,QAAA;EACA,eAAA;AAqqCJ;AAlqCE;EACE,UAAA;EACA,UAAA;EACA,eAAA;AAoqCJ;AAjqCE;EACE,YAAA;EACA,qBAAA;AAmqCJ;AAhqCE;EACE,mBAAA;EACA,aAAA;EACA,eAAA;AAkqCJ;AA/pCE;EAhLF;IAiLI,eAAA;IACA,gBAAA;EAkqCF;EAhqCE;IACE,WAAA;IACA,YAAA;EAkqCJ;AACF;;AA9pCA,gBAAA;AACA;EACE,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAiqCF;AA/pCE;EAVF;IAWI,kBAAA;IACA,iBAAA;EAkqCF;AACF;AAhqCE;EAfF;IAgBI,kBAAA;IACA,iBAAA;EAmqCF;AACF;AAjqCE;EApBF;IAqBI,kBAAA;IACA,iBAAA;EAoqCF;AACF;;AAjqCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAoqCF;AAlqCE;EARF;IASI,eAAA;EAqqCF;AACF;;AAlqCA;EACE,mBAAA;EACA,yDAAA;AAqqCF;AAnqCE;EACE,YAAA;EACA,YAAA;AAqqCJ;AAnqCI;EAJF;IAKI,YAAA;EAsqCJ;AACF;AApqCI;EARF;IASI,YAAA;EAuqCJ;AACF;;AAnqCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAsqCF;AApqCE;EARF;IASI,eAAA;IACA,iBAAA;EAuqCF;AACF;AArqCE;EAbF;IAcI,eAAA;IACA,iBAAA;EAwqCF;AACF;;AArqCA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAwqCF;AAtqCE;EARF;IASI,eAAA;IACA,iBAAA;EAyqCF;AACF;AAvqCE;EAbF;IAcI,eAAA;IACA,iBAAA;EA0qCF;AACF;;AAvqCA;EACE;IACE,UAAA;IACA,2BAAA;EA0qCF;EAxqCA;IACE,UAAA;IACA,wBAAA;EA0qCF;AACF","sourcesContent":["@import '../../styles/Variables/Variables.scss';\n\n/* Breakpoints: 1200px (tablet), 1024px (small tablet), 768px (phone), 576px (large phone), 480px (small phone), 360px (xs) */\n\n.managerDashboardWrap {\n  min-height: calc(100vh - 60px);\n  background: transparent;\n  font-family: 'Lufga', 'Inter', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;\n  color: #242220;\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0;\n  overflow-x: hidden;\n  padding-bottom: env(safe-area-inset-bottom, 0);\n\n  @media (max-width: 360px) {\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n.container {\n  display: flex;\n  gap: 42px;\n  margin: 0 auto;\n  padding: 12px 0 12px 30px;\n  position: relative;\n  min-width: 0;\n\n  @media (max-width: 1440px) {\n    max-width: 100%;\n    gap: 32px;\n    padding: 12px 20px;\n  }\n\n  @media (max-width: 1200px) {\n    gap: 28px;\n    padding: 12px 20px;\n  }\n\n  @media (max-width: 1024px) {\n    flex-direction: column;\n    gap: 24px;\n    padding: 12px 20px;\n  }\n\n  @media (max-width: 768px) {\n    padding: 12px 16px;\n    gap: 20px;\n  }\n\n  @media (max-width: 576px) {\n    padding: 12px 14px;\n    gap: 18px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 10px 12px;\n    gap: 16px;\n  }\n\n  @media (max-width: 360px) {\n    padding: 8px 10px;\n    gap: 12px;\n  }\n}\n\n/* ============ SIDE MENU ============ */\n.sideMenu {\n  width: 256px;\n  min-height: 400px;\n  max-height: 1022px;\n  position: relative;\n  flex-shrink: 0;\n\n  @media (max-width: 1200px) {\n    width: 220px;\n  }\n\n  @media (max-width: 1024px) {\n    width: 100%;\n    min-height: auto;\n    max-height: none;\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n}\n\n.sideMenuBackground {\n  position: absolute;\n  inset: 0;\n  background: white;\n  border: 0.8px solid #ececee;\n  border-radius: 20px;\n  filter: blur(0.5px);\n}\n\n.arrowToggle {\n  position: absolute;\n  left: 238px;\n  top: 82px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10;\n\n  @media (max-width: 1024px) {\n    display: none;\n  }\n}\n\n.arrow {\n  transform: rotate(270deg);\n}\n\n.sideMenuContent {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  align-items: center;\n  padding: 34px 0;\n  width: 256px;\n\n  @media (max-width: 1200px) {\n    width: 100%;\n  }\n\n  @media (max-width: 1024px) {\n    width: 100%;\n    padding: 24px 0;\n    gap: 16px;\n  }\n\n  @media (max-width: 768px) {\n    padding: 20px 0;\n    gap: 14px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 16px 0;\n    gap: 12px;\n  }\n}\n\n/* Profile Header */\n.profileHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 176px;\n\n  @media (max-width: 1024px) {\n    width: auto;\n    padding: 0 20px;\n  }\n}\n\n.profilePic {\n  position: relative;\n  width: 48px;\n  height: 48px;\n}\n\n.avatarCircle {\n  position: absolute;\n  inset: 0;\n  width: 48px;\n  height: 48px;\n  background: radial-gradient(50% 50% at 50% 50%, rgba(205, 71, 243, 0.8) 0%, rgba(205, 71, 243, 0) 100%);\n  border-radius: 50%;\n}\n\n.avatarImg {\n  position: absolute;\n  inset: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.profileInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 116px;\n}\n\n.roleText {\n  font-family: 'Lufga', sans-serif;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: rgba(36, 34, 32, 0.4);\n  margin: 0;\n}\n\n.nameRow {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.name {\n  font-family: 'Lufga', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #242220;\n  margin: 0;\n  white-space: nowrap;\n}\n\n/* Dividers */\n.divider {\n  width: 100%;\n  height: 0.5px;\n  opacity: 0.24;\n  background: radial-gradient(50% 50% at 50% 50%, rgba(67, 44, 44, 1) 0%, rgba(80, 28, 28, 0) 100%);\n}\n\n/* Promo Block */\n.promoBlock {\n  background: rgba(255, 255, 255, 0.12);\n  border: 0.5px solid rgba(245, 239, 235, 0.16);\n  border-radius: 28px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 208px;\n\n  @media (max-width: 1024px) {\n    width: 100%;\n    max-width: 400px;\n    margin: 0 auto;\n  }\n\n  @media (max-width: 768px) {\n    border-radius: 20px;\n    padding: 14px;\n    gap: 16px;\n    max-width: 100%;\n  }\n\n  @media (max-width: 480px) {\n    padding: 12px;\n    gap: 14px;\n    border-radius: 16px;\n  }\n}\n\n.promoText {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.promoTitle {\n  font-family: 'Lufga', sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.56;\n  letter-spacing: 0.16px;\n  color: #242220;\n  margin: 0;\n\n  @media (max-width: 768px) {\n    font-size: 15px;\n  }\n}\n\n.promoDescription {\n  font-family: 'Lufga', sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: rgba(36, 34, 32, 0.56);\n  margin: 0;\n\n  @media (max-width: 768px) {\n    font-size: 12px;\n  }\n}\n\n.createEventBtn {\n  background: #cd47f3;\n  border: none;\n  border-radius: 12px;\n  padding: 11px 24px 11px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 48px;\n  min-height: 44px; /* Touch target */\n  box-shadow: 0px 4px 24px 0px rgba(161, 6, 204, 0.3);\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  font-family: 'Lufga', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.3;\n  color: white;\n\n  &:hover {\n    background: #b83ad8;\n    transform: translateY(-2px);\n  }\n\n  @media (max-width: 768px) {\n    font-size: 13px;\n    height: 44px;\n    min-height: 44px;\n    padding: 10px 20px 10px 16px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 12px;\n    padding: 10px 16px;\n  }\n}\n\n/* Main Menu */\n.mainMenu {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n\n.menuTitle {\n  padding: 0 20px;\n\n  p {\n    font-family: 'Lufga', sans-serif;\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 0.4px;\n    text-transform: uppercase;\n    color: rgba(36, 34, 32, 0.4);\n    margin: 0;\n  }\n}\n\n.menuList {\n  display: flex;\n  flex-direction: column;\n  width: 208px;\n  margin: 0 auto;\n\n  @media (max-width: 1200px) {\n    width: 100%;\n    max-width: 208px;\n  }\n\n  @media (max-width: 1024px) {\n    width: 100%;\n    max-width: 100%;\n    padding: 0 20px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 0 12px;\n  }\n}\n\n.menuItem {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 20px;\n  border-radius: 12px;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.3s ease;\n\n  span {\n    font-family: 'Lufga', sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    color: #736b66;\n    flex: 1;\n\n    @media (max-width: 768px) {\n      font-size: 13px;\n    }\n  }\n\n  &:hover {\n    background: rgba(206, 84, 189, 0.05);\n  }\n\n  @media (max-width: 768px) {\n    padding: 14px 16px;\n    gap: 12px;\n  }\n}\n\n.menuItemActive {\n  background: rgba(206, 84, 189, 0.1);\n  isolation: isolate;\n\n  &:hover {\n    background: rgba(206, 84, 189, 0.1);\n  }\n}\n\n.activeIndicator {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n  height: 34px;\n  background: #cd47f3;\n  border-radius: 30px 0 0 30px;\n}\n\n.menuItemActiveText {\n  color: #cd47f3 !important;\n  font-weight: 500 !important;\n}\n\n.menuIcon {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.menuArrow {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.menuDivider {\n  width: 100%;\n  height: 0.5px;\n  opacity: 0.24;\n  background: radial-gradient(50% 50% at 50% 50%, rgba(67, 44, 44, 1) 0%, rgba(80, 28, 28, 0) 100%);\n  margin: 8px 0;\n}\n\n.signOutText {\n  color: red !important;\n}\n\n/* ============ MAIN CONTENT ============ */\n.mainContent {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 1101px;\n  max-width: 100%;\n  min-width: 0;\n\n  @media (max-width: 1024px) {\n    width: 100%;\n  }\n\n  @media (max-width: 768px) {\n    gap: 20px;\n  }\n}\n\n/* Header */\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    gap: 20px;\n    align-items: flex-start;\n    margin-top: 16px;\n  }\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n\n  @media (max-width: 768px) {\n    gap: 10px;\n    align-items: flex-start;\n    margin-left: -6px;\n  }\n}\n\n.logo {\n  width: 83px;\n  height: 83px;\n  position: relative;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n\n  @media (max-width: 768px) {\n    width: 60px;\n    height: 60px;\n  }\n}\n\n.welcomeText {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  h1 {\n    font-family: 'Lufga', sans-serif;\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 36px;\n    color: #111827;\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n\n    @media (max-width: 768px) {\n      font-size: 22px;\n      line-height: 28px;\n      white-space: normal;\n    }\n\n    @media (max-width: 480px) {\n      font-size: 20px;\n      line-height: 26px;\n    }\n  }\n\n  p {\n    font-family: 'Lufga', sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    color: #4b5563;\n    margin: 0;\n\n    @media (max-width: 768px) {\n      font-size: 14px;\n      line-height: 20px;\n    }\n  }\n}\n\n.notification {\n  position: relative;\n  background: #ffffff;\n  border: 1px solid #7FA9B8;\n  border-radius: 14px;\n  width: 42px;\n  height: 42px;\n  min-width: 42px;\n  min-height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n\n  svg path {\n    fill: #131F43;\n  }\n\n  &:hover {\n    background: #f0e9fd;\n    border-color: #9b51e0;\n  }\n\n  @media (max-width: 768px) {\n    width: 44px;\n    height: 44px;\n    min-width: 44px;\n    min-height: 44px;\n    position: fixed;\n    top: max(12px, env(safe-area-inset-top, 0));\n    right: max(16px, env(safe-area-inset-right, 0));\n    z-index: 9997;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  }\n\n  @media (max-width: 360px) {\n    right: max(10px, env(safe-area-inset-right, 0));\n  }\n}\n\n.notificationDot {\n  position: absolute;\n  top: 5px;\n  right: 9px;\n  width: 10px;\n  height: 10px;\n  background: #FF0000;\n  border-radius: 50%;\n}\n\n/* Stats Cards */\n.statsCards {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  background: white;\n  border: 0.8px solid #ececee;\n  border-radius: 16px;\n  min-height: 96px;\n  padding: 16px 6px 24px;\n  margin-bottom: 32px;\n\n  @media (max-width: 768px) {\n    min-height: auto;\n    padding: 16px 6px;\n    margin-bottom: 24px;\n  }\n}\n\n.statsRow {\n  position: relative;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  align-items: center;\n  gap: 0;\n  padding: 0;\n  z-index: 1;\n  width: 100%;\n\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n    align-items: stretch;\n  }\n\n  @media (max-width: 768px) {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n\n  @media (max-width: 480px) {\n    gap: 10px;\n  }\n\n  @media (max-width: 360px) {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n}\n\n.statItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n\n  @media (max-width: 768px) {\n    width: auto;\n    gap: 10px;\n  }\n}\n\n.statIcon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  flex-shrink: 0;\n\n  @media (max-width: 768px) {\n    width: 40px;\n    height: 40px;\n    padding: 8px;\n  }\n}\n\n.statIconOrange {\n  background: #fff2e9;\n}\n\n.statIconPurple {\n  background: #ede8ff;\n}\n\n.statIconBlue {\n  background: #eaf9ff;\n}\n\n.statIconPink {\n  background: #ffebef;\n}\n\n.statIconGreen {\n  background: #ebfff8;\n}\n\n.statInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.statLabel {\n  font-family: 'Lufga', sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  color: #736b66;\n  margin: 0;\n  line-height: 1.2;\n\n  @media (max-width: 768px) {\n    font-size: 12px;\n  }\n}\n\n.statValue {\n  font-family: 'Lufga', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  color: #132941;\n  margin: 0;\n  line-height: 1.2;\n\n  @media (max-width: 768px) {\n    font-size: 15px;\n  }\n}\n\n.statSubtext {\n  font-family: 'Lufga', sans-serif;\n  font-size: 11px;\n  font-weight: 400;\n  color: #9ca3af;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.statItemContainer {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 768px) {\n    width: auto;\n    background: #f8f9fc;\n    border-radius: 10px;\n    padding: 10px 12px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 8px 10px;\n    border-radius: 8px;\n  }\n}\n\n/* Separator after each card (hidden only after the last card) */\n.statDivider {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 0;\n  width: 1px;\n  height: 48px;\n  opacity: 0.34;\n  background: #cbcbcf;\n  flex-shrink: 0;\n\n  @media (max-width: 1200px) {\n    display: none;\n  }\n}\n\n.statsRow .statItemContainer:last-child .statDivider {\n  display: none;\n}\n\n/* Desktop: slight padding for Total Revenue and Active Vendors labels */\n@media (min-width: 769px) {\n  .statsRow .statItemContainer:nth-child(3) .statInfo,\n  .statsRow .statItemContainer:nth-child(4) .statInfo {\n    padding-left: 2px;\n  }\n}\n\n@media (max-width: 480px) {\n  .statsRow .statItemContainer {\n    padding: 8px 10px;\n    border-radius: 8px;\n  }\n\n  .statIcon {\n    width: 36px;\n    height: 36px;\n    padding: 6px;\n  }\n\n  .statLabel {\n    font-size: 11px;\n  }\n\n  .statValue {\n    font-size: 14px;\n  }\n}\n\n/* Charts Section */\n.chartsSection {\n  display: flex;\n  gap: 32px;\n  width: 100%;\n  min-width: 0;\n\n  @media (max-width: 1200px) {\n    gap: 24px;\n  }\n\n  @media (max-width: 1024px) {\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  @media (max-width: 768px) {\n    gap: 20px;\n  }\n\n  @media (max-width: 480px) {\n    gap: 16px;\n  }\n\n  @media (max-width: 360px) {\n    gap: 12px;\n  }\n}\n\n.chartCard {\n  flex: 1;\n  background: white;\n  border: 0.642px solid #ececee;\n  border-radius: 16.06px;\n  padding: 18px 18px 25px;\n  min-width: 0;\n  overflow: hidden;\n\n  @media (max-width: 768px) {\n    padding: 16px;\n    border-radius: 14px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 14px;\n    border-radius: 12px;\n  }\n\n  @media (max-width: 360px) {\n    padding: 12px;\n  }\n}\n\n.chartHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n  gap: 12px;\n\n  h3 {\n    font-family: 'Lufga', sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 28px;\n    color: #111827;\n    margin: 0;\n    min-width: 0;\n\n    @media (max-width: 768px) {\n      font-size: 16px;\n      line-height: 24px;\n    }\n\n    @media (max-width: 480px) {\n      font-size: 15px;\n      line-height: 22px;\n    }\n  }\n\n  @media (max-width: 768px) {\n    margin-bottom: 20px;\n  }\n\n  @media (max-width: 480px) {\n    margin-bottom: 16px;\n    gap: 10px;\n  }\n}\n\n.selectWrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.chartSelect {\n  background: white;\n  border: 0.642px solid #dbdbdb;\n  border-radius: 8px;\n  padding: 8.03px 32px 8.03px 8.03px;\n  font-family: 'Lufga', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: black;\n  cursor: pointer;\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  &:focus {\n    border-color: #cd47f3;\n  }\n\n  @media (max-width: 768px) {\n    font-size: 13px;\n    padding: 6px 28px 6px 6px;\n  }\n}\n\n.selectArrow {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  transition: transform 0.2s ease;\n\n  @media (max-width: 768px) {\n    right: 8px;\n    \n    svg {\n      width: 10px;\n      height: 7px;\n    }\n  }\n}\n\n.chartWrapper {\n  position: relative;\n  width: 100%;\n  min-height: 200px;\n\n  @media (max-width: 768px) {\n    min-height: 180px;\n  }\n\n  @media (max-width: 480px) {\n    min-height: 160px;\n  }\n}\n\n.chartPlaceholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 250px;\n  background: #f8f9fc;\n  border-radius: 12px;\n  padding: 40px 20px;\n\n  @media (max-width: 768px) {\n    min-height: 200px;\n    padding: 30px 16px;\n  }\n\n  @media (max-width: 480px) {\n    min-height: 180px;\n    padding: 24px 12px;\n  }\n\n  @media (max-width: 360px) {\n    min-height: 160px;\n    padding: 20px 10px;\n  }\n}\n\n.chartLabel {\n  font-family: 'Lufga', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  color: #736b66;\n  margin: 0 0 8px 0;\n  text-align: center;\n\n  @media (max-width: 768px) {\n    font-size: 14px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 13px;\n  }\n}\n\n.chartSubtext {\n  font-family: 'Lufga', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #92959e;\n  margin: 0;\n  text-align: center;\n\n  @media (max-width: 768px) {\n    font-size: 13px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 12px;\n  }\n}\n\n/* Quick Actions */\n.quickActionsCard {\n  flex: 0 0 323px;\n  background: white;\n  border: 0.642px solid #ececee;\n  border-radius: 16.06px;\n  padding: 20px 25px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n\n  @media (max-width: 1200px) {\n    flex: 1 1 280px;\n    min-width: 0;\n  }\n\n  @media (max-width: 1024px) {\n    flex: 1;\n  }\n\n  @media (max-width: 768px) {\n    padding: 16px;\n    border-radius: 14px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 14px;\n    border-radius: 12px;\n  }\n\n  h3 {\n    font-family: 'Lufga', sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 28px;\n    color: #111827;\n    margin: 0;\n\n    @media (max-width: 768px) {\n      font-size: 16px;\n      line-height: 24px;\n    }\n\n    @media (max-width: 480px) {\n      font-size: 15px;\n      line-height: 22px;\n    }\n  }\n}\n\n.quickActionsList {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  @media (max-width: 480px) {\n    gap: 10px;\n  }\n}\n\n.quickActionBtn {\n  background: white;\n  border: 0.8px solid #ececee;\n  border-radius: 12px;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 62px;\n  min-height: 44px; /* Min touch target for accessibility */\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  span {\n    font-family: 'Lufga', sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 19.679px;\n    color: black;\n\n    @media (max-width: 768px) {\n      font-size: 13px;\n    }\n\n    @media (max-width: 480px) {\n      font-size: 12px;\n    }\n  }\n\n  &:hover {\n    background: #f8f9fc;\n    border-color: #cd47f3;\n  }\n\n  @media (max-width: 768px) {\n    height: 56px;\n    min-height: 48px;\n    padding: 10px 12px;\n  }\n\n  @media (max-width: 480px) {\n    height: 52px;\n    min-height: 44px;\n    padding: 10px;\n  }\n}\n\n.actionIcon {\n  width: 32px;\n  height: 32px;\n  border-radius: 6.56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.actionIconBlue {\n  background: rgba(59, 130, 246, 0.1);\n}\n\n.actionIconGreen {\n  background: rgba(16, 185, 129, 0.1);\n}\n\n.actionIconPurple {\n  background: rgba(139, 92, 246, 0.1);\n}\n\n.actionIconOrange {\n  background: rgba(245, 158, 11, 0.1);\n}\n\n/* Bottom Section */\n.bottomSection {\n  display: flex;\n  gap: 32px;\n  width: 100%;\n  min-width: 0;\n  overflow: hidden;\n\n  @media (max-width: 1200px) {\n    gap: 24px;\n  }\n\n  @media (max-width: 1024px) {\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  @media (max-width: 768px) {\n    gap: 20px;\n  }\n\n  @media (max-width: 576px) {\n    gap: 18px;\n  }\n\n  @media (max-width: 480px) {\n    gap: 16px;\n  }\n}\n\n.revenueTrendCard {\n  flex: 1;\n  min-width: 0;\n  background: white;\n  border: 0.642px solid #ececee;\n  border-radius: 16.06px;\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  overflow: hidden;\n\n  @media (max-width: 768px) {\n    padding: 16px;\n    gap: 20px;\n    border-radius: 14px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 14px;\n    gap: 16px;\n    border-radius: 12px;\n  }\n}\n\n.revenueDivider {\n  width: 100%;\n  height: 1px;\n  opacity: 0.34;\n  background: radial-gradient(50% 50% at 50% 50%, rgba(62, 44, 67, 1) 0%, rgba(68, 28, 80, 0.2) 100%);\n}\n\n.revenueFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.revenueInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.revenueLabel {\n  font-family: 'Lufga', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #4b5563;\n  margin: 0;\n  line-height: normal;\n\n  @media (max-width: 768px) {\n    font-size: 13px;\n  }\n}\n\n.revenueValue {\n  font-family: 'Lufga', sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0;\n  line-height: normal;\n\n  @media (max-width: 768px) {\n    font-size: 18px;\n  }\n}\n\n/* Upcoming Events */\n.upcomingEventsCard {\n  flex: 1;\n  min-width: 0;\n  background: white;\n  border: 0.642px solid #ececee;\n  border-radius: 16.06px;\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  overflow: visible;\n\n  @media (max-width: 768px) {\n    padding: 16px;\n    gap: 16px;\n  }\n\n  @media (max-width: 576px) {\n    padding: 14px;\n    gap: 14px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 12px;\n    gap: 12px;\n  }\n}\n\n.eventsHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  flex-shrink: 0;\n\n  h3 {\n    font-family: 'Lufga', sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 28px;\n    color: #111827;\n    margin: 0;\n    min-width: 0;\n\n    @media (max-width: 768px) {\n      font-size: 16px;\n      line-height: 24px;\n    }\n\n    @media (max-width: 480px) {\n      font-size: 15px;\n    }\n  }\n}\n\n.viewAllLink {\n  font-family: 'Lufga', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #cd47f3;\n  text-decoration: none;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  padding: 8px 0;\n  margin: 0;\n  text-align: right;\n  min-height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 13px;\n    padding: 6px 0;\n  }\n}\n\n.eventsList {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: 420px;\n  padding-bottom: 16px;\n\n  @media (max-width: 768px) {\n    max-height: 360px;\n    padding-bottom: 20px;\n  }\n\n  @media (max-width: 480px) {\n    max-height: 320px;\n    gap: 12px;\n    padding-bottom: 20px;\n  }\n}\n\n.eventsLoadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 160px;\n}\n\n.eventsLoadingText {\n  text-align: center;\n  color: #736b66;\n  font-size: 16px;\n  font-weight: 400;\n  font-family: 'Lufga', 'Inter', sans-serif;\n  margin: 0;\n}\n\n.chartLoading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 160px;\n  text-align: center;\n  color: #736b66;\n  font-size: 16px;\n  font-weight: 400;\n  font-family: 'Lufga', 'Inter', sans-serif;\n  margin: 0;\n}\n\n/* Section page loader — same typography as global PageLoader; sized for cards (not full viewport) */\n.pageLoader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 200px;\n  box-sizing: border-box;\n}\n\n.pageLoaderText {\n  font-family: 'Lufga', 'Inter', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: #736b66;\n  margin: 0;\n  text-align: center;\n  line-height: 1.5;\n  visibility: visible;\n}\n\n.eventCard {\n  background: white;\n  border: 0.8px solid #ececee;\n  border-radius: 20px;\n  padding: 13px;\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 12px;\n  transition: all 0.3s ease;\n  min-width: 0;\n  overflow: visible;\n\n  &:hover {\n    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);\n  }\n\n  @media (max-width: 768px) {\n    padding: 10px;\n    gap: 10px;\n  }\n\n  @media (max-width: 576px) {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 12px;\n    gap: 12px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 10px;\n    gap: 10px;\n  }\n}\n\n.eventImage {\n  width: 60px !important;\n  height: 107px !important;\n  min-width: 60px !important;\n  min-height: 107px !important;\n  aspect-ratio: 9 / 16 !important;\n  border-radius: 8px;\n  object-fit: cover;\n  flex-shrink: 0;\n\n  @media (max-width: 768px) {\n    width: 52px !important;\n    height: 93px !important;\n    min-width: 52px !important;\n    min-height: 93px !important;\n    aspect-ratio: 9 / 16 !important;\n  }\n\n  @media (max-width: 576px) {\n    width: 100% !important;\n    min-width: unset !important;\n    height: auto !important;\n    min-height: unset !important;\n    aspect-ratio: 9 / 16 !important;\n    align-self: stretch;\n  }\n}\n\n.eventDetails {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  overflow: hidden;\n\n  @media (max-width: 576px) {\n    flex: none;\n    width: 100%;\n  }\n}\n\n.eventTitleRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  flex-wrap: wrap;\n  min-width: 0;\n\n  h4 {\n    font-family: 'Lufga', sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px;\n    color: #111827;\n    margin: 0;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    min-width: 0;\n    flex: 1 1 auto;\n\n    @media (max-width: 768px) {\n      font-size: 14px;\n      line-height: 20px;\n    }\n\n    @media (max-width: 576px) {\n      max-width: 100%;\n    }\n\n    @media (max-width: 480px) {\n      font-size: 13px;\n      line-height: 18px;\n    }\n  }\n}\n\n.badgeLive {\n  background: #DCFCE7;\n  border-radius: 9999px;\n  padding: 2px 12px;\n  font-family: 'Lufga', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: #166534;\n  display: inline-block;\n  line-height: normal;\n  flex-shrink: 0;\n\n  @media (max-width: 480px) {\n    font-size: 11px;\n    padding: 2px 10px;\n  }\n}\n\n.badgeDraft {\n  background: #fef3c7;\n  border-radius: 9999px;\n  padding: 2px 10px;\n  font-family: 'Lufga', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: #92400e;\n  display: inline-block;\n  line-height: normal;\n  flex-shrink: 0;\n\n  @media (max-width: 480px) {\n    font-size: 11px;\n    padding: 2px 8px;\n  }\n}\n\n.eventDate {\n  font-family: 'Lufga', sans-serif;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 20px;\n  color: #4b5563;\n  margin: 0;\n  word-break: break-word;\n  overflow-wrap: break-word;\n\n  @media (max-width: 768px) {\n    font-size: 12px;\n    line-height: 18px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 11px;\n    line-height: 16px;\n  }\n}\n\n.eventTickets {\n  font-family: 'Lufga', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: #6b7280;\n  margin: 0;\n  word-break: break-word;\n\n  @media (max-width: 480px) {\n    font-size: 11px;\n  }\n}\n\n.eventWarning {\n  font-family: 'Lufga', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  color: #ea580c;\n  margin: 0;\n}\n\n.eventActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  flex-basis: 100%;\n  justify-content: flex-end;\n  align-items: center;\n  padding-left: 76px;\n  padding-bottom: 4px;\n  min-width: 0;\n\n  @media (max-width: 1200px) {\n    padding-left: 0;\n  }\n\n  @media (max-width: 768px) {\n    gap: 10px;\n    padding-left: 0;\n    padding-bottom: 6px;\n  }\n\n  @media (max-width: 576px) {\n    flex-basis: auto;\n    width: 100%;\n    justify-content: flex-start;\n    padding-top: 10px;\n    padding-bottom: 4px;\n    margin-top: 4px;\n    border-top: 1px solid #f3f4f6;\n  }\n\n  @media (max-width: 480px) {\n    gap: 8px;\n    padding-top: 8px;\n    padding-bottom: 4px;\n    margin-top: 6px;\n  }\n}\n\n.eventActionBtn {\n  background: transparent;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  position: relative;\n  min-width: 44px;\n  min-height: 44px;\n  touch-action: manipulation;\n\n  &[data-tooltip]::after {\n    content: attr(data-tooltip);\n    position: absolute;\n    bottom: calc(100% + 8px);\n    left: 50%;\n    transform: translateX(-50%);\n    background: #1f2937;\n    color: #ffffff;\n    font-size: 12px;\n    font-family: 'Lufga', 'Inter', sans-serif;\n    font-weight: 400;\n    line-height: 1.4;\n    padding: 6px 10px;\n    border-radius: 6px;\n    white-space: nowrap;\n    pointer-events: none;\n    opacity: 0;\n    transition: opacity 0.15s ease;\n    z-index: 9999;\n  }\n\n  &[data-tooltip]::before {\n    content: '';\n    position: absolute;\n    bottom: calc(100% + 3px);\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: #1f2937;\n    pointer-events: none;\n    opacity: 0;\n    transition: opacity 0.15s ease;\n    z-index: 9999;\n  }\n\n  /* Show on hover (desktop), focus, and active (touch) */\n  &[data-tooltip]:hover::after,\n  &[data-tooltip]:hover::before,\n  &[data-tooltip]:focus::after,\n  &[data-tooltip]:focus::before,\n  &[data-tooltip]:focus-visible::after,\n  &[data-tooltip]:focus-visible::before,\n  &[data-tooltip]:active::after,\n  &[data-tooltip]:active::before {\n    opacity: 1;\n  }\n\n  /* On mobile: position tooltip below button, scale down with screen size */\n  @media (max-width: 768px) {\n    padding: 6px;\n\n    &[data-tooltip]::after {\n      bottom: auto;\n      top: calc(100% + 6px);\n      left: 50%;\n      transform: translateX(-50%);\n      font-size: 12px;\n      padding: 6px 10px;\n      border-radius: 5px;\n    }\n\n    &[data-tooltip]::before {\n      bottom: auto;\n      top: calc(100% + 2px);\n      left: 50%;\n      transform: translateX(-50%);\n      border-width: 4px;\n      border-top-color: transparent;\n      border-bottom-color: #1f2937;\n    }\n\n    &[data-tooltip][data-tooltip-align='right']::after {\n      left: auto;\n      right: 0;\n      transform: none;\n      top: calc(100% + 6px);\n    }\n\n    &[data-tooltip][data-tooltip-align='right']::before {\n      left: auto;\n      right: 8px;\n      transform: none;\n      top: calc(100% + 2px);\n      border-top-color: transparent;\n      border-bottom-color: #1f2937;\n    }\n  }\n\n  @media (max-width: 576px) {\n    &[data-tooltip]::after {\n      font-size: 11px;\n      padding: 5px 8px;\n      border-radius: 4px;\n      top: calc(100% + 5px);\n    }\n\n    &[data-tooltip]::before {\n      border-width: 4px;\n      top: calc(100% + 1px);\n    }\n\n    &[data-tooltip][data-tooltip-align='right']::after {\n      top: calc(100% + 5px);\n    }\n\n    &[data-tooltip][data-tooltip-align='right']::before {\n      top: calc(100% + 1px);\n    }\n  }\n\n  @media (max-width: 480px) {\n    &[data-tooltip]::after {\n      font-size: 10px;\n      padding: 4px 6px;\n      border-radius: 4px;\n      top: calc(100% + 4px);\n    }\n\n    &[data-tooltip]::before {\n      border-width: 3px;\n      top: calc(100% + 1px);\n    }\n\n    &[data-tooltip][data-tooltip-align='right']::after {\n      top: calc(100% + 4px);\n    }\n\n    &[data-tooltip][data-tooltip-align='right']::before {\n      top: calc(100% + 1px);\n    }\n  }\n\n  @media (max-width: 360px) {\n    &[data-tooltip]::after {\n      font-size: 9px;\n      padding: 3px 5px;\n    }\n  }\n\n  &[data-tooltip][data-tooltip-align='right']::after {\n    left: auto;\n    right: 0;\n    transform: none;\n  }\n\n  &[data-tooltip][data-tooltip-align='right']::before {\n    left: auto;\n    right: 8px;\n    transform: none;\n  }\n\n  &:hover {\n    opacity: 0.7;\n    transform: scale(1.1);\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.35;\n    transform: none;\n  }\n\n  @media (max-width: 768px) {\n    min-width: 40px;\n    min-height: 40px;\n\n    svg {\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n/* Empty State */\n.emptyStateCard {\n  background: transparent;\n  border: none;\n  border-radius: 16.06px;\n  padding: 60px 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n\n  @media (max-width: 768px) {\n    padding: 40px 20px;\n    min-height: 350px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 32px 16px;\n    min-height: 300px;\n  }\n\n  @media (max-width: 360px) {\n    padding: 24px 12px;\n    min-height: 260px;\n  }\n}\n\n.emptyStateContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  max-width: 400px;\n\n  @media (max-width: 480px) {\n    max-width: 100%;\n  }\n}\n\n.emptyStateIcon {\n  margin-bottom: 24px;\n  animation: fadeInUp 0.6s ease-out;\n\n  svg {\n    width: 200px;\n    height: auto;\n\n    @media (max-width: 768px) {\n      width: 160px;\n    }\n\n    @media (max-width: 480px) {\n      width: 120px;\n    }\n  }\n}\n\n.emptyStateTitle {\n  font-family: 'Lufga', sans-serif;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 32px;\n  color: #283340;\n  margin: 0px;\n\n  @media (max-width: 768px) {\n    font-size: 18px;\n    line-height: 28px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 16px;\n    line-height: 24px;\n  }\n}\n\n.emptyStateDescription {\n  font-family: 'Lufga', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #283340;\n  margin: 0;\n\n  @media (max-width: 768px) {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 13px;\n    line-height: 18px;\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}","/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  overflow-y: auto;\n  padding-right: 0px;\n}\n\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-Color: $mainBg;\n  border-radius: 8px;\n}\n\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-Color: $darkTheme_darkBlue;\n}\n\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /*height: calc(100vh - 160px);*/\n  height: 100%;\n  min-height: auto !important;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.cst_vendr input {\n  min-height: 35px !important;\n}\n\n.cst_vendr .form-control {\n  background-color: #f5f6fa;\n  border: none;\n}\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n.bodythemeNew {\n  background-color: #f5f6fa;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 2;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: #f5f6fa;\n}\n\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color !important;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinklight:hover svg path,\n.menulinklightSelected svg path {\n  fill: #fff !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.tableheadlight th {\n  color: $white-color;\n}\n\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\n\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\n\nth:first-child {\n  border-radius: 0px;\n}\n\ntd:last-child {\n  border-radius: 0px;\n}\n\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: $white-color;\n    cursor: auto;\n  }\n  p{\n  line-height: 24px;\n}\n\n}\n\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border-radius: 5px !important;\n  background-color: transparent !important;\n  border: solid 1px $primary-color !important;\n  color: $primary-color !important;\n  min-width: 113px !important;\n}\n\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color !important;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addDltBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color !important;\n  min-width: 130px !important;\n  height: 50px !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $darkTheme_darkBlue !important;\n}\n\n.confirmBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 35px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 20px;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {}\n\n.modalStyleDark {}\n\n.delPopContainer .modal-content {\n  border-radius: 10px;\n  min-width: 399px;\n}\n\n.larg_model .modal-dialog {\n  max-width: 100% !important;\n}\n\n.larg_model .modal-content {\n  /* display: inline-block; */\n  height: 100%;\n  max-width: 900px;\n  margin: auto;\n  border-radius: 54px !important;\n  background: #FFF;\n  padding: 53px 53px 23px;\n}\n\n.larg_model .modal-header {\n  padding: 0px 0px 23px;\n  border-bottom: 1px dashed #D4D9EE;\n  display: block;\n}\n\nbody .btn-primary:hover {\n  background-color: transparent;\n  border-color: #131F43;\n  color: #131F43;\n  fill: #131F43;\n  border: 1px solid;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: .375rem 2.25rem .375rem .75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-image: url(../../assets/select_arow.svg) !important;\n}\n\nthead .CustomTable_tableheadlight__HuHZw th:first-child,\nthead .CustomTable_tableheaddark__nwqb4 th:first-child {\n  border-radius: 5px 0 0 0px;\n  display: math;\n}\n\nth:first-child {\n  border-radius: 0px;\n  position: absolute;\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 270px;\n  }\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n    overflow-x: hidden !important;\n  }\n\n  .cont2 {\n    height: auto !important;\n    padding-bottom: 10px !important;\n  }\n}\n\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n\n@media only screen and (max-width: 767px) {\n  .sectionright {\n    float: unset !important;\n  }\n\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px 10px 15px !important;\n  }\n\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 110px;\n  }\n\n  .delPopContainer .modal-content {\n    min-width: 100%;\n  }\n\n  .delPopContainer .modal-body {\n    padding: 15px;\n  }\n\n  .larg_model .modal-content {\n    border-radius: 20px !important;\n    padding: 22px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n\n  /*.tableheadlight th {\n    min-width: 120px;\n  } */\n}\n\n/* vk new changes */\n.active_show_outer {\n\n  h2 {\n    color: var(--Font-black, #0B0D0F);\n    font-family: Urbanist;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    @media screen and (max-width:768px) {\n      margin-top: 15px;\n    }\n  }\n\n  .active_show_inner {\n    width: 100%;\n    display: block;\n\n    .act_box_img {\n      margin-bottom: 12px;\n      min-height: 400px;\n      object-fit: cover;\n      overflow: hidden;\n      height: 400px;\n      max-height: 400px;\n      @media (max-width: 767px) {\n        min-height: 300px;\n        height: 300px;\n        max-height: 300px;\n      }\n      img {\n        max-height: 400px;\n        /* align-self: stretch; */\n        width: 100%;\n        height: 100%;\n        border-radius: 12px;\n        object-fit: cover;\n      }\n    }\n\n    .act_box_cnt {\n      width: 100%;\n      display: block;\nsvg{\n  flex-shrink: 0;\n}\n      .act_box_bdg {\n        width: 100%;\n        margin-bottom: 12px;\n\n        span {\n          background: url(../../assets/ongoing.png) right top no-repeat;\n          width: 111px;\n          display: block;\n          height: 34px;\n          color: var(--White, #FFF);\n          font-size: 18px;\n          font-style: normal;\n          font-weight: 500;\n          padding: 3px 8px;\n        }\n\n        .sold {\n          background: url(../../assets/sold.png) right top no-repeat !important;\n        }\n\n      }\n\n      h3 {\n        color: var(--Secondary, #132941);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 26.304px;\n        margin: 0;\n      }\n\n      p {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        margin-bottom: 5px;\n\n        span {\n          color: var(--Light-1, #736B66);\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 26.304px;\n        }\n\n        .timezone_code_pill {\n          display: inline-block;\n          padding: 2px 8px;\n          margin-left: 4px;\n          background: #e0f2fe;\n          color: #0369a1;\n          font-size: 12px;\n          font-weight: 600;\n          letter-spacing: 0.02em;\n          border-radius: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* vk new changes */\n#attent_details_row1{\n    margin-bottom: 0 !important;\n}\n.attent_details {\n  .attent_details_inner {\n    display: flex;\n    gap: 61px;\n    padding: 20px;\n    border-radius: 5px;\n    background: #FFF;\n    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);\n    align-items: center;\n\n    @media (max-width: 576px) {\n      display: block !important;\n    }\n\n    @media (max-width: 992px) {\n      display: flex;\n      gap: 20px;\n      align-items: start;\n    }\n\n    .attent_details_inner_l {\n      img {\n        width: 187px;\n        height: 207px;\n        flex-shrink: 0;\n        object-fit: cover;\n      }\n    }\n\n    .attent_details_inner_r {\n      flex: 1;\n\n      .attent_details_row {\n        display: flex;\n        gap: 20px;\n        margin-bottom: 28px;\n\n        @media (max-width: 992px) {\n          margin-bottom: 0px;\n          display: inline-block;\n          width: 100%;\n        }\n\n        .attent_details_row_box {\n          flex: 1;\n          width: 22%;\n\n          @media (max-width: 576px) {\n            margin: 15px 0px 10px !important;\n            width: 100% !important;\n          }\n\n          @media (max-width: 992px) {\n            margin-bottom: 15px;\n            float: left;\n            margin-right: 0;\n            width: 50%;\n            padding-right: 10px;\n          }\n\n          p {\n            margin-bottom: 10px;\n            color: #727272;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n          }\n\n          h5 {\n            color: #131F43;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            word-wrap: break-word;\n          }\n        }\n      }\n\n      .attent_details_row_last {\n        margin-bottom: 0px !important;\n        &.interesting_fact {\n          padding-top: 30px;\n          .attent_details_row_box {\n            width: 100%;\n            h5 {\n              color: #131F43;\n              font-size: 16px;\n              font-style: normal;\n              font-weight: 500;\n              line-height: 24px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n .showbox_sec{\n      display: flex;\n    justify-content: flex-start;\n    gap: 0;\n    flex-direction: row;\n    flex-wrap: wrap;\n    @media screen and (max-width:500px) {\n      justify-content: center;\n    }\n }\n.show_box_main {\n  margin: 10px 0px;\n\n  .show_box {\n    min-height: 600px;\n    width: 300px;\n    float: left;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-right: 18px;\n    }\n    @media (max-width: 767px) {\n      min-height: 500px;\n      width: 200px !important;\n    }\n\n    img {\n      max-height: 400px;\n      height: 100%;\n      width: 100%;\n\n      @media (max-width: 767px) {\n        max-height: 300px !important;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0px !important;\n    }\n  }\n\n  .no_show_box {\n    width: 350px;\n    margin: 0 auto 20px;\n    display: block;\n  \n    @media (max-width: 767px) {\n      width: 250px !important;\n    }\n  \n    img {\n      max-height: 450px;\n      height: 100%;\n      width: 100%;\n  \n      @media (max-width: 767px) {\n        max-height: 350px !important;\n      }\n    }\n    h6 {\n      color: #000;\n      text-align: center;\n      font-size: 26px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      margin-top: 20px;\n      @media only screen and (max-width: 600px) {\n        font-size: 20px;\n      }\n    }\n  }\n  \n\n}\n\n.attent_flex {\n  justify-content: space-between !important;\n  gap: 30px;\n  align-items: center;\n\n  h5 {\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `ManagerDashboard_dashboard__V1Jm8`,
	"dashboardContain": `ManagerDashboard_dashboardContain__YHSYl`,
	"bodythemedark": `ManagerDashboard_bodythemedark__iFTXF`,
	"cont2": `ManagerDashboard_cont2__+vbCD`,
	"top_header": `ManagerDashboard_top_header__h0v1i`,
	"top_header_inner": `ManagerDashboard_top_header_inner__C2o3F`,
	"subLink": `ManagerDashboard_subLink__KfY5X`,
	"cst_vendr": `ManagerDashboard_cst_vendr__+HUCx`,
	"form-control": `ManagerDashboard_form-control__JXIhW`,
	"footer": `ManagerDashboard_footer__0PZX3`,
	"bodythemelight": `ManagerDashboard_bodythemelight__uo0IO`,
	"bodythemeNew": `ManagerDashboard_bodythemeNew__Dlybx`,
	"headerthemelight": `ManagerDashboard_headerthemelight__jsrKj`,
	"headerthemedark": `ManagerDashboard_headerthemedark__484DS`,
	"menuthemelight": `ManagerDashboard_menuthemelight__MdJ2i`,
	"menuthemedark": `ManagerDashboard_menuthemedark__ZKyZF`,
	"menulinklight": `ManagerDashboard_menulinklight__DS2ZT`,
	"menulinkdarkSelected": `ManagerDashboard_menulinkdarkSelected__FUO-t`,
	"menulinklightSelected": `ManagerDashboard_menulinklightSelected__2RGM8`,
	"menulinkdark": `ManagerDashboard_menulinkdark__XJEFF`,
	"sub_arrow": `ManagerDashboard_sub_arrow__RNK9E`,
	"headinglight": `ManagerDashboard_headinglight__9p6zm`,
	"headingdark": `ManagerDashboard_headingdark__gmWm8`,
	"searchboxlight": `ManagerDashboard_searchboxlight__68OdW`,
	"searchboxdark": `ManagerDashboard_searchboxdark__1LeH9`,
	"tableheadlight": `ManagerDashboard_tableheadlight__JsZMi`,
	"tableheaddark": `ManagerDashboard_tableheaddark__WdsJz`,
	"table": `ManagerDashboard_table__T9Yb+`,
	"table-borderless": `ManagerDashboard_table-borderless__X6yRe`,
	"left-section": `ManagerDashboard_left-section__HudV4`,
	"tablebodylight": `ManagerDashboard_tablebodylight__VlaBZ`,
	"tablebodydark": `ManagerDashboard_tablebodydark__4qXqa`,
	"paginationlight": `ManagerDashboard_paginationlight__rdhxA`,
	"paginationdark": `ManagerDashboard_paginationdark__M1l2p`,
	"formthemelight": `ManagerDashboard_formthemelight__ryMW6`,
	"formthemedark": `ManagerDashboard_formthemedark__mxeuv`,
	"viewformlight": `ManagerDashboard_viewformlight__y3yi8`,
	"permissionboxlight": `ManagerDashboard_permissionboxlight__qZZa3`,
	"permissionboxdark": `ManagerDashboard_permissionboxdark__siTrO`,
	"errormsgclr": `ManagerDashboard_errormsgclr__-JPzw`,
	"graphclrlight": `ManagerDashboard_graphclrlight__igJYK`,
	"graphclrdark": `ManagerDashboard_graphclrdark__CsRde`,
	"card1bglight": `ManagerDashboard_card1bglight__TlXvX`,
	"card1bgdark": `ManagerDashboard_card1bgdark__88TAE`,
	"card2bglight": `ManagerDashboard_card2bglight__dKe4a`,
	"card2bgdark": `ManagerDashboard_card2bgdark__+0Pjl`,
	"card3bglight": `ManagerDashboard_card3bglight__+Irxb`,
	"card3bgdark": `ManagerDashboard_card3bgdark__CR9gh`,
	"card4bglight": `ManagerDashboard_card4bglight__ZqSMH`,
	"card4bgdark": `ManagerDashboard_card4bgdark__Npc5V`,
	"actionbtnlight": `ManagerDashboard_actionbtnlight__CILfC`,
	"actionbtndark": `ManagerDashboard_actionbtndark__gd73c`,
	"profiledropdownlight": `ManagerDashboard_profiledropdownlight__3Luiv`,
	"profiledropdowndark": `ManagerDashboard_profiledropdowndark__45qA6`,
	"settingsection": `ManagerDashboard_settingsection__M+J1d`,
	"addform": `ManagerDashboard_addform__aiztJ`,
	"savebtn": `ManagerDashboard_savebtn__GGZxf`,
	"profile_conatiner": `ManagerDashboard_profile_conatiner__ALk40`,
	"ag-theme-alpine": `ManagerDashboard_ag-theme-alpine__fYKut`,
	"ag-row": `ManagerDashboard_ag-row__D7L05`,
	"formbtn": `ManagerDashboard_formbtn__LyU5E`,
	"resetbtn": `ManagerDashboard_resetbtn__lcA26`,
	"addBtn": `ManagerDashboard_addBtn__2T8jP`,
	"addDltBtn": `ManagerDashboard_addDltBtn__eENjf`,
	"addbtnlight": `ManagerDashboard_addbtnlight__xK01k`,
	"addbtndark": `ManagerDashboard_addbtndark__dt7-k`,
	"cust_addBtn": `ManagerDashboard_cust_addBtn__k+-1V`,
	"deleteBtn": `ManagerDashboard_deleteBtn__ZbUql`,
	"confirmBtn": `ManagerDashboard_confirmBtn__bdk5W`,
	"delPopContainer": `ManagerDashboard_delPopContainer__fuxVD`,
	"modal-body": `ManagerDashboard_modal-body__8LzsZ`,
	"delet_icon": `ManagerDashboard_delet_icon__6YS4s`,
	"arrowback": `ManagerDashboard_arrowback__h5Lwc`,
	"drpdwn_btn": `ManagerDashboard_drpdwn_btn__RWNOM`,
	"empname": `ManagerDashboard_empname__GPV-6`,
	"navitemli": `ManagerDashboard_navitemli__SzYbZ`,
	"tabnavli": `ManagerDashboard_tabnavli__kMrh3`,
	"settingsgeneral": `ManagerDashboard_settingsgeneral__axeic`,
	"settingslinks": `ManagerDashboard_settingslinks__sMwKi`,
	"dropdown_menu_contain": `ManagerDashboard_dropdown_menu_contain__INTJM`,
	"dropdown_item": `ManagerDashboard_dropdown_item__sCNNx`,
	"profile_arrrow_dwn": `ManagerDashboard_profile_arrrow_dwn__XkTwd`,
	"dateinputbox1": `ManagerDashboard_dateinputbox1__+F-7e`,
	"modal-content": `ManagerDashboard_modal-content__TpXVt`,
	"larg_model": `ManagerDashboard_larg_model__TixdG`,
	"modal-dialog": `ManagerDashboard_modal-dialog__mioIi`,
	"modal-header": `ManagerDashboard_modal-header__ulLwz`,
	"btn-primary": `ManagerDashboard_btn-primary__pNhOe`,
	"form-select": `ManagerDashboard_form-select__oZjY0`,
	"CustomTable_tableheadlight__HuHZw": `ManagerDashboard_CustomTable_tableheadlight__HuHZw__9BhHI`,
	"CustomTable_tableheaddark__nwqb4": `ManagerDashboard_CustomTable_tableheaddark__nwqb4__bttNM`,
	"sectionright": `ManagerDashboard_sectionright__pBOOG`,
	"exer_modal_contain": `ManagerDashboard_exer_modal_contain__c1maA`,
	"active_show_outer": `ManagerDashboard_active_show_outer__T899X`,
	"active_show_inner": `ManagerDashboard_active_show_inner__Owgsx`,
	"act_box_img": `ManagerDashboard_act_box_img__hpxRz`,
	"act_box_cnt": `ManagerDashboard_act_box_cnt__0MIK7`,
	"act_box_bdg": `ManagerDashboard_act_box_bdg__x0eTX`,
	"sold": `ManagerDashboard_sold__EniWc`,
	"timezone_code_pill": `ManagerDashboard_timezone_code_pill__S-OES`,
	"attent_details_row1": `ManagerDashboard_attent_details_row1__SNPpy`,
	"attent_details": `ManagerDashboard_attent_details__axa9w`,
	"attent_details_inner": `ManagerDashboard_attent_details_inner__V+02m`,
	"attent_details_inner_l": `ManagerDashboard_attent_details_inner_l__WrAP5`,
	"attent_details_inner_r": `ManagerDashboard_attent_details_inner_r__rh3iT`,
	"attent_details_row": `ManagerDashboard_attent_details_row__0gaIv`,
	"attent_details_row_box": `ManagerDashboard_attent_details_row_box__7vOHu`,
	"attent_details_row_last": `ManagerDashboard_attent_details_row_last__0ZSxU`,
	"interesting_fact": `ManagerDashboard_interesting_fact__F8ZXn`,
	"showbox_sec": `ManagerDashboard_showbox_sec__xqX9M`,
	"show_box_main": `ManagerDashboard_show_box_main__TrXVF`,
	"show_box": `ManagerDashboard_show_box__2+r4u`,
	"no_show_box": `ManagerDashboard_no_show_box__I-b6D`,
	"attent_flex": `ManagerDashboard_attent_flex__ltS6x`,
	"managerDashboardWrap": `ManagerDashboard_managerDashboardWrap__ye8Tn`,
	"container": `ManagerDashboard_container__7WSqw`,
	"sideMenu": `ManagerDashboard_sideMenu__Ip5KN`,
	"sideMenuBackground": `ManagerDashboard_sideMenuBackground__MBl1F`,
	"arrowToggle": `ManagerDashboard_arrowToggle__HoE9C`,
	"arrow": `ManagerDashboard_arrow__9Thrq`,
	"sideMenuContent": `ManagerDashboard_sideMenuContent__twnrp`,
	"profileHeader": `ManagerDashboard_profileHeader__e-OJ9`,
	"profilePic": `ManagerDashboard_profilePic__u5IqT`,
	"avatarCircle": `ManagerDashboard_avatarCircle__yLjDJ`,
	"avatarImg": `ManagerDashboard_avatarImg__yCKnT`,
	"profileInfo": `ManagerDashboard_profileInfo__6J2Nz`,
	"roleText": `ManagerDashboard_roleText__486Aw`,
	"nameRow": `ManagerDashboard_nameRow__Gccfe`,
	"name": `ManagerDashboard_name__BiJKA`,
	"divider": `ManagerDashboard_divider__iQKAm`,
	"promoBlock": `ManagerDashboard_promoBlock__ja9hN`,
	"promoText": `ManagerDashboard_promoText__HOeX9`,
	"promoTitle": `ManagerDashboard_promoTitle__4fh2K`,
	"promoDescription": `ManagerDashboard_promoDescription__6SPGM`,
	"createEventBtn": `ManagerDashboard_createEventBtn__4Wxxd`,
	"mainMenu": `ManagerDashboard_mainMenu__psGPC`,
	"menuTitle": `ManagerDashboard_menuTitle__9NjQM`,
	"menuList": `ManagerDashboard_menuList__ERMLW`,
	"menuItem": `ManagerDashboard_menuItem__EK-YM`,
	"menuItemActive": `ManagerDashboard_menuItemActive__O3e+7`,
	"activeIndicator": `ManagerDashboard_activeIndicator__pVdVn`,
	"menuItemActiveText": `ManagerDashboard_menuItemActiveText__sAufY`,
	"menuIcon": `ManagerDashboard_menuIcon__Hn1lw`,
	"menuArrow": `ManagerDashboard_menuArrow__795Zb`,
	"menuDivider": `ManagerDashboard_menuDivider__-vTBS`,
	"signOutText": `ManagerDashboard_signOutText__LGtug`,
	"mainContent": `ManagerDashboard_mainContent__kMf7D`,
	"header": `ManagerDashboard_header__kCLqC`,
	"headerLeft": `ManagerDashboard_headerLeft__xZCQw`,
	"logo": `ManagerDashboard_logo__8T-yS`,
	"welcomeText": `ManagerDashboard_welcomeText__xWmKT`,
	"notification": `ManagerDashboard_notification__Z4Z2r`,
	"notificationDot": `ManagerDashboard_notificationDot__dB6Bq`,
	"statsCards": `ManagerDashboard_statsCards__d5+3M`,
	"statsRow": `ManagerDashboard_statsRow__RkvUH`,
	"statItem": `ManagerDashboard_statItem__j6Hcj`,
	"statIcon": `ManagerDashboard_statIcon__let6H`,
	"statIconOrange": `ManagerDashboard_statIconOrange__s-gBx`,
	"statIconPurple": `ManagerDashboard_statIconPurple__uxCXj`,
	"statIconBlue": `ManagerDashboard_statIconBlue__iW+oN`,
	"statIconPink": `ManagerDashboard_statIconPink__XU9rT`,
	"statIconGreen": `ManagerDashboard_statIconGreen__1a4T8`,
	"statInfo": `ManagerDashboard_statInfo__Y9dpv`,
	"statLabel": `ManagerDashboard_statLabel__1+24K`,
	"statValue": `ManagerDashboard_statValue__JXKhS`,
	"statSubtext": `ManagerDashboard_statSubtext__hKFjm`,
	"statItemContainer": `ManagerDashboard_statItemContainer__lRcdV`,
	"statDivider": `ManagerDashboard_statDivider__j064S`,
	"chartsSection": `ManagerDashboard_chartsSection__T6bL3`,
	"chartCard": `ManagerDashboard_chartCard__r78si`,
	"chartHeader": `ManagerDashboard_chartHeader__xom5w`,
	"selectWrapper": `ManagerDashboard_selectWrapper__8sx+7`,
	"chartSelect": `ManagerDashboard_chartSelect__Sfys9`,
	"selectArrow": `ManagerDashboard_selectArrow__9zkxA`,
	"chartWrapper": `ManagerDashboard_chartWrapper__OGutu`,
	"chartPlaceholder": `ManagerDashboard_chartPlaceholder__x9yWf`,
	"chartLabel": `ManagerDashboard_chartLabel__0Jf6R`,
	"chartSubtext": `ManagerDashboard_chartSubtext__fZXe9`,
	"quickActionsCard": `ManagerDashboard_quickActionsCard__y+gK2`,
	"quickActionsList": `ManagerDashboard_quickActionsList__sL4vH`,
	"quickActionBtn": `ManagerDashboard_quickActionBtn__7u1L2`,
	"actionIcon": `ManagerDashboard_actionIcon__CJZKk`,
	"actionIconBlue": `ManagerDashboard_actionIconBlue__R4Hf-`,
	"actionIconGreen": `ManagerDashboard_actionIconGreen__0qh9y`,
	"actionIconPurple": `ManagerDashboard_actionIconPurple__qiTvZ`,
	"actionIconOrange": `ManagerDashboard_actionIconOrange__9ynm3`,
	"bottomSection": `ManagerDashboard_bottomSection__0dSZX`,
	"revenueTrendCard": `ManagerDashboard_revenueTrendCard__dUTcg`,
	"revenueDivider": `ManagerDashboard_revenueDivider__JGLf9`,
	"revenueFooter": `ManagerDashboard_revenueFooter__RdYao`,
	"revenueInfo": `ManagerDashboard_revenueInfo__2DxT-`,
	"revenueLabel": `ManagerDashboard_revenueLabel__yuSk4`,
	"revenueValue": `ManagerDashboard_revenueValue__KTZpz`,
	"upcomingEventsCard": `ManagerDashboard_upcomingEventsCard__ceSdA`,
	"eventsHeader": `ManagerDashboard_eventsHeader__YMun2`,
	"viewAllLink": `ManagerDashboard_viewAllLink__8lT44`,
	"eventsList": `ManagerDashboard_eventsList__1c5jT`,
	"eventsLoadingContainer": `ManagerDashboard_eventsLoadingContainer__qhMlW`,
	"eventsLoadingText": `ManagerDashboard_eventsLoadingText__4DqSx`,
	"chartLoading": `ManagerDashboard_chartLoading__3nn4L`,
	"pageLoader": `ManagerDashboard_pageLoader__NzME6`,
	"pageLoaderText": `ManagerDashboard_pageLoaderText__IKW4S`,
	"eventCard": `ManagerDashboard_eventCard__l85f1`,
	"eventImage": `ManagerDashboard_eventImage__JlBz6`,
	"eventDetails": `ManagerDashboard_eventDetails__bkhi4`,
	"eventTitleRow": `ManagerDashboard_eventTitleRow__Y1FGp`,
	"badgeLive": `ManagerDashboard_badgeLive__lvQNx`,
	"badgeDraft": `ManagerDashboard_badgeDraft__ELeuG`,
	"eventDate": `ManagerDashboard_eventDate__gaENv`,
	"eventTickets": `ManagerDashboard_eventTickets__Kk16L`,
	"eventWarning": `ManagerDashboard_eventWarning__Wv7rl`,
	"eventActions": `ManagerDashboard_eventActions__nFx9o`,
	"eventActionBtn": `ManagerDashboard_eventActionBtn__YSAR9`,
	"emptyStateCard": `ManagerDashboard_emptyStateCard__Uvtts`,
	"emptyStateContent": `ManagerDashboard_emptyStateContent__tnMDi`,
	"emptyStateIcon": `ManagerDashboard_emptyStateIcon__bsaBe`,
	"fadeInUp": `ManagerDashboard_fadeInUp__Z9Zvj`,
	"emptyStateTitle": `ManagerDashboard_emptyStateTitle__Ghekg`,
	"emptyStateDescription": `ManagerDashboard_emptyStateDescription__nYBcd`
};
export default ___CSS_LOADER_EXPORT___;
